export type PrizmIconSvgsId =
  | 'charts-diagrams_bar-axis'
  | 'charts-diagrams_bar-basic'
  | 'charts-diagrams_bar-columns-axis_x'
  | 'charts-diagrams_bar-columns'
  | 'charts-diagrams_bar-square'
  | 'charts-diagrams_bar-stacked-axis'
  | 'charts-diagrams_bar-stacked'
  | 'charts-diagrams_charts-histogram-chart-dashed'
  | 'charts-diagrams_column'
  | 'charts-diagrams_doughnut'
  | 'charts-diagrams_gantt'
  | 'charts-diagrams_gauge'
  | 'charts-diagrams_hexagon-axis'
  | 'charts-diagrams_hexagon'
  | 'charts-diagrams_histogram-axis'
  | 'charts-diagrams_line-axis_x'
  | 'charts-diagrams_line-axis-arrow_down'
  | 'charts-diagrams_line-axis'
  | 'charts-diagrams_line-down'
  | 'charts-diagrams_line-multiple_y_axis-x'
  | 'charts-diagrams_line-multiple_y_axis'
  | 'charts-diagrams_line-up'
  | 'charts-diagrams_line'
  | 'charts-diagrams_pie-line-nested'
  | 'charts-diagrams_pie-line'
  | 'charts-diagrams_pie-pentagon'
  | 'charts-diagrams_pie-several_parts'
  | 'charts-diagrams_pie-simple'
  | 'charts-diagrams_pie'
  | 'charts-diagrams_range'
  | 'charts-diagrams_scatter-axis'
  | 'charts-diagrams_scatter-basic'
  | 'charts-diagrams_scatter'
  | 'communication-connection_at-sign'
  | 'communication-connection_bluetooth'
  | 'communication-connection_bubble-message-add'
  | 'communication-connection_bubble-message-attention'
  | 'communication-connection_bubble-message-circle'
  | 'communication-connection_bubble-message-empty'
  | 'communication-connection_bubble-message-off'
  | 'communication-connection_bubble-message-question'
  | 'communication-connection_bubble-message-text'
  | 'communication-connection_bubble-message'
  | 'communication-connection_headphones'
  | 'communication-connection_heart-empty'
  | 'communication-connection_heart-fill'
  | 'communication-connection_mail-open'
  | 'communication-connection_mail'
  | 'communication-connection_mailbox'
  | 'communication-connection_messaging-telegram-send'
  | 'communication-connection_messaging-telegram'
  | 'communication-connection_phone-active-call'
  | 'communication-connection_phone-cancelled'
  | 'communication-connection_phone-minus'
  | 'communication-connection_phone-off'
  | 'communication-connection_phone-paused'
  | 'communication-connection_phone-plus'
  | 'communication-connection_phone'
  | 'communication-connection_share-left'
  | 'communication-connection_share-right'
  | 'communication-connection_shareing'
  | 'communication-connection_signal-access-point'
  | 'communication-connection_signal-off'
  | 'communication-connection_signal-radio-tower'
  | 'communication-connection_signal'
  | 'communication-connection_star-empty'
  | 'communication-connection_star-fill'
  | 'communication-connection_star-half-fill'
  | 'communication-connection_support-man'
  | 'communication-connection_thumb-down'
  | 'communication-connection_thumb-up'
  | 'communication-connection_wifi-off'
  | 'communication-connection_wifi'
  | 'data-network_database-chek'
  | 'data-network_database-json'
  | 'data-network_database-magnifying_glass'
  | 'data-network_database-minus'
  | 'data-network_database-plus'
  | 'data-network_database-sql'
  | 'data-network_database-xmark'
  | 'data-network_database'
  | 'data-network_ethernet'
  | 'data-network_lan-connect'
  | 'data-network_lan-disconnect'
  | 'data-network_lan-pending'
  | 'data-network_network-1'
  | 'data-network_network-2'
  | 'data-network_network-3'
  | 'data-network_network-wired'
  | 'data-network_server-close'
  | 'data-network_server-download'
  | 'data-network_server-minus'
  | 'data-network_server-one'
  | 'data-network_server-plus'
  | 'data-network_server-security'
  | 'data-network_server-shield'
  | 'data-network_server-slash-up-line'
  | 'data-network_server-slash'
  | 'data-network_server-up-line'
  | 'data-network_server-upload'
  | 'data-network_server'
  | 'date-time_alarm-clock'
  | 'date-time_alarm-plus'
  | 'date-time_calendar-blank'
  | 'date-time_calendar-check'
  | 'date-time_calendar-clock'
  | 'date-time_calendar-deleted'
  | 'date-time_calendar-event'
  | 'date-time_calendar-plus'
  | 'date-time_calendar-question'
  | 'date-time_calendar-range'
  | 'date-time_calendar-today'
  | 'date-time_calendar'
  | 'date-time_clock-add'
  | 'date-time_clock-arrow-down'
  | 'date-time_clock-arrow-right'
  | 'date-time_clock-arrow-up'
  | 'date-time_clock-deleted'
  | 'date-time_clock-exclamation'
  | 'date-time_clock-line-end'
  | 'date-time_clock-rotate-left'
  | 'date-time_clock-rotate-right'
  | 'date-time_clock'
  | 'date-time_letter-day'
  | 'date-time_letter-hour'
  | 'date-time_letter-minute'
  | 'date-time_letter-month'
  | 'date-time_letter-second'
  | 'date-time_letter-time'
  | 'date-time_letter-year'
  | 'date-time_sandglass'
  | 'date-time_stopwatch'
  | 'date-time_sumbol-asterisk'
  | 'documents-folders_book_stack'
  | 'documents-folders_box-open-arrow-down'
  | 'documents-folders_box'
  | 'documents-folders_cloud_arrow_down'
  | 'documents-folders_cloud_arrow_up_inside'
  | 'documents-folders_cloud_arrow_up'
  | 'documents-folders_cloud_check'
  | 'documents-folders_cloud'
  | 'documents-folders_collection-2'
  | 'documents-folders_file_arrow_down_left'
  | 'documents-folders_file_arrow_down'
  | 'documents-folders_file_arrow_up'
  | 'documents-folders_file_arrow'
  | 'documents-folders_file_arrows_up_right'
  | 'documents-folders_file_camera'
  | 'documents-folders_file_cross_out'
  | 'documents-folders_file_cross'
  | 'documents-folders_file_doc'
  | 'documents-folders_file_docx'
  | 'documents-folders_file_dot'
  | 'documents-folders_file_empty'
  | 'documents-folders_file-exclamatio'
  | 'documents-folders_file_eye'
  | 'documents-folders_file_filled'
  | 'documents-folders_file_image'
  | 'documents-folders_file_magnifying_glass'
  | 'documents-folders_file_minus'
  | 'documents-folders_file_pdf'
  | 'documents-folders_file_pen'
  | 'documents-folders_file_play'
  | 'documents-folders_file_plus'
  | 'documents-folders_file_ppt'
  | 'documents-folders_file_pptx'
  | 'documents-folders_file_txt'
  | 'documents-folders_file_up_right'
  | 'documents-folders_file_xls'
  | 'documents-folders_file_xlsx'
  | 'documents-folders_floppy_cross_out'
  | 'documents-folders_floppy_cross'
  | 'documents-folders_floppy_pen'
  | 'documents-folders_floppy_star'
  | 'documents-folders_floppy'
  | 'documents-folders_folder_arrow_down_left'
  | 'documents-folders_folder_arrow_down'
  | 'documents-folders_folder_arrow_up_right'
  | 'documents-folders_folder_cross'
  | 'documents-folders_folder_dot'
  | 'documents-folders_folder_minus'
  | 'documents-folders_folder_plus'
  | 'documents-folders_folder_open'
  | 'documents-folders_folder_underline_minus'
  | 'documents-folders_folder_underline_plus'
  | 'documents-folders_folder_underline'
  | 'documents-folders_folder'
  | 'documents-folders_list_square'
  | 'documents-folders_list-tree-archive'
  | 'documents-folders_list-tree'
  | 'documents-folders_list'
  | 'documents-folders_ontology'
  | 'documents-folders_specification'
  | 'documents-folders_square_arrows_curve_right_down'
  | 'documents-folders_square_arrows_curve_up_right'
  | 'documents-folders_square_excel'
  | 'documents-folders_square_powerpoint'
  | 'documents-folders_square_word'
  | 'documents-folders_tablet'
  | 'editor-decor_agenda-fill'
  | 'editor-decor_align-bottom'
  | 'editor-decor_align-center-h'
  | 'editor-decor_align-center-v'
  | 'editor-decor_align-center'
  | 'editor-decor_align-justify'
  | 'editor-decor_align-left'
  | 'editor-decor_align-right'
  | 'editor-decor_align-top'
  | 'editor-decor_array-fill'
  | 'editor-decor_bars-sort'
  | 'editor-decor_bdrv-administration'
  | 'editor-decor_bezier-curve'
  | 'editor-decor_bold'
  | 'editor-decor_border-all'
  | 'editor-decor_border-bottom'
  | 'editor-decor_border-center-h'
  | 'editor-decor_border-center-v'
  | 'editor-decor_border-inner'
  | 'editor-decor_border-left'
  | 'editor-decor_border-none'
  | 'editor-decor_border-outer'
  | 'editor-decor_border-right'
  | 'editor-decor_border-top-left'
  | 'editor-decor_border-top'
  | 'editor-decor_brackets-curly'
  | 'editor-decor_brackets-square'
  | 'editor-decor_broom'
  | 'editor-decor_browser'
  | 'editor-decor_brush'
  | 'editor-decor_carousel-fill'
  | 'editor-decor_code-download'
  | 'editor-decor_code-simple'
  | 'editor-decor_code'
  | 'editor-decor_collage-fill'
  | 'editor-decor_column-fill'
  | 'editor-decor_component'
  | 'editor-decor_copy-column'
  | 'editor-decor_copy-row'
  | 'editor-decor_crop'
  | 'editor-decor_dashboard-fill'
  | 'editor-decor_dashboard-variant-fill'
  | 'editor-decor_day-fill'
  | 'editor-decor_eraser'
  | 'editor-decor_fill'
  | 'editor-decor_function'
  | 'editor-decor_grid-fill'
  | 'editor-decor_grid'
  | 'editor-decor_hashtag'
  | 'editor-decor_headline-fill'
  | 'editor-decor_indent_arrow-left'
  | 'editor-decor_indent_arrow-right'
  | 'editor-decor_italic'
  | 'editor-decor_keyboard_close'
  | 'editor-decor_keyboard'
  | 'editor-decor_layer-group-slash'
  | 'editor-decor_layer-group'
  | 'editor-decor_line-height'
  | 'editor-decor_list-fill'
  | 'editor-decor_list-ol'
  | 'editor-decor_list-ul'
  | 'editor-decor_magic_wand'
  | 'editor-decor_module-fill'
  | 'editor-decor_npm'
  | 'editor-decor_object-down-subtract'
  | 'editor-decor_object-exclude'
  | 'editor-decor_object-intersect'
  | 'editor-decor_object-selection'
  | 'editor-decor_object-union'
  | 'editor-decor_object-up-subtract'
  | 'editor-decor_object'
  | 'editor-decor_palette'
  | 'editor-decor_panel-down'
  | 'editor-decor_panel-left'
  | 'editor-decor_panel-right'
  | 'editor-decor_panel-top'
  | 'editor-decor_pantone'
  | 'editor-decor_percent'
  | 'editor-decor_pi'
  | 'editor-decor_plus-column-right'
  | 'editor-decor_plus-column-top'
  | 'editor-decor_polyline'
  | 'editor-decor_quilt-fill'
  | 'editor-decor_ruler'
  | 'editor-decor_scissors'
  | 'editor-decor_send-backward'
  | 'editor-decor_send-forward'
  | 'editor-decor_sequential-fill'
  | 'editor-decor_shovel'
  | 'editor-decor_sigma'
  | 'editor-decor_square-bracket-curly-right-1'
  | 'editor-decor_square-bracket-curly-right'
  | 'editor-decor_square-bracket-left'
  | 'editor-decor_square-bracket-right'
  | 'editor-decor_square-divide'
  | 'editor-decor_square-minus'
  | 'editor-decor_square-multiply'
  | 'editor-decor_square-percent'
  | 'editor-decor_square-plus'
  | 'editor-decor_star-line'
  | 'editor-decor_strikethrough'
  | 'editor-decor_subskrit-down'
  | 'editor-decor_subskrit-up'
  | 'editor-decor_table-down'
  | 'editor-decor_table-magnifying_glass'
  | 'editor-decor_table-right'
  | 'editor-decor_table-transpose'
  | 'editor-decor_table'
  | 'editor-decor_text-color'
  | 'editor-decor_text'
  | 'editor-decor_underlined'
  | 'editor-decor_vector-circle-one-point'
  | 'editor-decor_vector-circle-two-point'
  | 'editor-decor_vector-circle'
  | 'editor-decor_vector-line'
  | 'editor-decor_vector-point'
  | 'editor-decor_vector-polygon'
  | 'editor-decor_vector-rectangle'
  | 'editor-decor_vector-square'
  | 'editor-decor_vector-triangle'
  | 'editor-decor_vectors-radius'
  | 'editor-decor_window'
  | 'editor-decor_xmark-column-right'
  | 'editor-decor_xmark-column-top'
  | 'logistics-transportation_airplane-side-view'
  | 'logistics-transportation_airplane-top-view'
  | 'logistics-transportation_ambulance-side-view'
  | 'logistics-transportation_car-jeep-side-view'
  | 'logistics-transportation_car-light-side-view'
  | 'logistics-transportation_concrete-mixer-side-view'
  | 'logistics-transportation_helicopter-side-view'
  | 'logistics-transportation_minibus-side-view'
  | 'logistics-transportation_paver-side-view'
  | 'logistics-transportation_pipe-node-side-view'
  | 'logistics-transportation_railcar-hopper-side-view'
  | 'logistics-transportation_railcar-side-view'
  | 'logistics-transportation_ship-front-view'
  | 'logistics-transportation_ship-side-view'
  | 'logistics-transportation_tankcar-oil-side-view'
  | 'logistics-transportation_tankcar-side-view'
  | 'logistics-transportation_truck-dump-side-view'
  | 'logistics-transportation_truck-empty-side-view'
  | 'logistics-transportation_truck-garbage-side-view'
  | 'logistics-transportation_truck-gasoline-side-view'
  | 'logistics-transportation_truck-side-view'
  | 'map-location_compass'
  | 'map-location_crosshairs-dot'
  | 'map-location_crosshairs-simple'
  | 'map-location_location-arrow'
  | 'map-location_location-directly'
  | 'map-location_location-dot'
  | 'map-location_location-minus'
  | 'map-location_location-plus'
  | 'map-location_location-slash'
  | 'map-location_location-user'
  | 'map-location_map-base'
  | 'map-location_map-pin'
  | 'map-location_map'
  | 'map-location_thumbtack-directly'
  | 'map-location_thumbtack'
  | 'map-location_world-2'
  | 'map-location_world'
  | 'multimedia-devices_android-pill'
  | 'multimedia-devices_android'
  | 'multimedia-devices_audio-speakers'
  | 'multimedia-devices_bookmark-music'
  | 'multimedia-devices_camera-front'
  | 'multimedia-devices_camera-movie-cross'
  | 'multimedia-devices_camera-movie'
  | 'multimedia-devices_camera'
  | 'multimedia-devices_cellphone-wireless'
  | 'multimedia-devices_cellphone'
  | 'multimedia-devices_circle-music'
  | 'multimedia-devices_clapperboard-cross'
  | 'multimedia-devices_clapperboard-open'
  | 'multimedia-devices_desktop-tower'
  | 'multimedia-devices_file-music'
  | 'multimedia-devices_film-cross'
  | 'multimedia-devices_film'
  | 'multimedia-devices_forvard-step'
  | 'multimedia-devices_forward'
  | 'multimedia-devices_hard-drive-outline'
  | 'multimedia-devices_image'
  | 'multimedia-devices_infinity'
  | 'multimedia-devices_input-device'
  | 'multimedia-devices_laptop-phone-slash'
  | 'multimedia-devices_laptop-phone'
  | 'multimedia-devices_laptop-slash'
  | 'multimedia-devices_laptop'
  | 'multimedia-devices_microphone-slash'
  | 'multimedia-devices_microphone'
  | 'multimedia-devices_monitor'
  | 'multimedia-devices_music-slash'
  | 'multimedia-devices_music'
  | 'multimedia-devices_pause'
  | 'multimedia-devices_play-back'
  | 'multimedia-devices_play'
  | 'multimedia-devices_printer'
  | 'multimedia-devices_push-button-cellphone'
  | 'multimedia-devices_return-step'
  | 'multimedia-devices_return'
  | 'multimedia-devices_square-music-double'
  | 'multimedia-devices_square-music'
  | 'multimedia-devices_stop'
  | 'multimedia-devices_tablet'
  | 'multimedia-devices_touchpad'
  | 'multimedia-devices_transmitter'
  | 'multimedia-devices_tv'
  | 'multimedia-devices_video-cross'
  | 'multimedia-devices_video-slash'
  | 'multimedia-devices_video'
  | 'multimedia-devices_voicemail'
  | 'multimedia-devices_volume-cross'
  | 'multimedia-devices_volume-low'
  | 'multimedia-devices_volume-minus'
  | 'multimedia-devices_volume-off'
  | 'multimedia-devices_volume-plus'
  | 'multimedia-devices_volume-slash'
  | 'multimedia-devices_volume'
  | 'multimedia-devices_watch'
  | 'multimedia-devices_webcam'
  | 'notifications-alerts_bell-fill'
  | 'notifications-alerts_bell-plus'
  | 'notifications-alerts_bell-ring-fill'
  | 'notifications-alerts_bell-ring'
  | 'notifications-alerts_bell-slash'
  | 'notifications-alerts_bell'
  | 'notifications-alerts_check-double'
  | 'notifications-alerts_chek'
  | 'notifications-alerts_circle-chek-empty'
  | 'notifications-alerts_circle-chek-fill'
  | 'notifications-alerts_circle-exclamation-empty'
  | 'notifications-alerts_circle-exclamation-fill'
  | 'notifications-alerts_circle-info-empty'
  | 'notifications-alerts_circle-info-fill'
  | 'notifications-alerts_circle-question-empty'
  | 'notifications-alerts_circle-question-fill'
  | 'notifications-alerts_decagram-chek-empty'
  | 'notifications-alerts_decagram-chek-fill'
  | 'notifications-alerts_decagram-exclamation-empty'
  | 'notifications-alerts_decagram-exclamation-fill'
  | 'notifications-alerts_exclamation'
  | 'notifications-alerts_flag-fill-red'
  | 'notifications-alerts_flag-fill'
  | 'notifications-alerts_flag'
  | 'notifications-alerts_hexagon-exclamation-empty'
  | 'notifications-alerts_hexagon-exclamation-fill'
  | 'notifications-alerts_info'
  | 'notifications-alerts_question'
  | 'notifications-alerts_square-exclamation-empty'
  | 'notifications-alerts_square-exclamation-fill'
  | 'notifications-alerts_square-info-empty'
  | 'notifications-alerts_square-info-fill'
  | 'notifications-alerts_square-question-empty'
  | 'notifications-alerts_square-question-fill'
  | 'notifications-alerts_triangle-cross-empty'
  | 'notifications-alerts_triangle-exclamation-empty'
  | 'notifications-alerts_triangle-exclamation-fill'
  | 'notifications-alerts_triangle-info-empty'
  | 'notifications-alerts_triangle-info-fill'
  | 'notifications-alerts_triangle-plus-empty'
  | 'other_award'
  | 'other_default-ico'
  | 'other_face-frown'
  | 'other_face-smile'
  | 'other_git-lab'
  | 'other_instagram'
  | 'other_logo-grey-z'
  | 'other_logo-s.grey'
  | 'other_map-marker-date-1'
  | 'other_map-marker-date-2'
  | 'other_owl'
  | 'other_portfel'
  | 'other_temperature-minus'
  | 'other_temperature-plus'
  | 'other_temperature'
  | 'other_template'
  | 'other_umbrella'
  | 'power-energy_battery-bolt'
  | 'power-energy_battery-empty'
  | 'power-energy_battery-exclametion_mark'
  | 'power-energy_battery-full'
  | 'power-energy_battery-half'
  | 'power-energy_battery-minus'
  | 'power-energy_battery-plus'
  | 'power-energy_battery-quarter'
  | 'power-energy_battery-three-quarters'
  | 'power-energy_energy-check'
  | 'power-energy_energy-slash'
  | 'power-energy_energy'
  | 'power-energy_pulse'
  | 'production-industry_balloon'
  | 'production-industry_boiler-hot-water-gas-and-oil'
  | 'production-industry_boiler'
  | 'production-industry_burn'
  | 'production-industry_carbon'
  | 'production-industry_cart-flatbed-container'
  | 'editor-decor_table-magnifying_2'
  | 'production-industry_container'
  | 'production-industry_containers'
  | 'production-industry_crane'
  | 'production-industry_cube-empty'
  | 'production-industry_cube-fill'
  | 'production-industry_cubes'
  | 'production-industry_early-version'
  | 'production-industry_electrics'
  | 'production-industry_exchanger'
  | 'production-industry_factory-pipe'
  | 'production-industry_factory-pipes'
  | 'production-industry_factory'
  | 'production-industry_fan'
  | 'production-industry_fire'
  | 'production-industry_flask-round-potion'
  | 'production-industry_flask'
  | 'production-industry_fuel-oil-tank'
  | 'production-industry_gas-monitoring'
  | 'production-industry_gas-pump'
  | 'production-industry_gas'
  | 'production-industry_gear-cooling'
  | 'production-industry_generator'
  | 'production-industry_lng-storage'
  | 'production-industry_medical'
  | 'production-industry_ni-fi-logo'
  | 'production-industry_oil-barrel'
  | 'production-industry_oil-canister'
  | 'production-industry_oil-droplet-arrows-all'
  | 'production-industry_oil-droplet-arrows-repeat-h'
  | 'production-industry_oil-droplet-chek'
  | 'production-industry_oil-droplet'
  | 'production-industry_oil-field'
  | 'production-industry_oil-tank'
  | 'production-industry_pipe-sensor'
  | 'production-industry_pipe-valve'
  | 'production-industry_pipeline_2'
  | 'production-industry_pipeline'
  | 'production-industry_press'
  | 'production-industry_pump-triangle-down'
  | 'production-industry_pump'
  | 'production-industry_radiation'
  | 'production-industry_respirator-1'
  | 'production-industry_respirator-2'
  | 'production-industry_respirator-3'
  | 'production-industry_respirator-4'
  | 'production-industry_respirator-5'
  | 'production-industry_respirator-6'
  | 'production-industry_seedling-circle'
  | 'production-industry_seedling-rectangle'
  | 'production-industry_seedling'
  | 'production-industry_separator'
  | 'production-industry_snake-cup'
  | 'production-industry_snowflake-up-to-bracket'
  | 'production-industry_snowflake'
  | 'production-industry_speed-reduction-cooling'
  | 'production-industry_steam-boiler'
  | 'production-industry_steam-turbine'
  | 'production-industry_steam'
  | 'production-industry_tank-1'
  | 'production-industry_tank'
  | 'production-industry_vial-arrow-rotate-left'
  | 'production-industry_vial-flask'
  | 'production-industry_vial-xmark'
  | 'production-industry_vial'
  | 'production-industry_water-heater'
  | 'production-industry_water-pump'
  | 'settings-tools_ban'
  | 'settings-tools_bars'
  | 'settings-tools_circle-plus-fill'
  | 'settings-tools_circle-plus'
  | 'settings-tools_circle-xmark-fill'
  | 'settings-tools_circle-xmark'
  | 'settings-tools_copy'
  | 'settings-tools_delete-content'
  | 'settings-tools_droplet-slash'
  | 'settings-tools_droplet'
  | 'settings-tools_ellipsis-grid'
  | 'settings-tools_ellipsis-h'
  | 'settings-tools_ellipsis-v'
  | 'settings-tools_eye-closed'
  | 'settings-tools_eye-slash'
  | 'settings-tools_eye'
  | 'settings-tools_filter'
  | 'settings-tools_gear-5'
  | 'settings-tools_gear-8'
  | 'settings-tools_grip-dots-vertical'
  | 'settings-tools_house-mini'
  | 'settings-tools_house'
  | 'settings-tools_key'
  | 'settings-tools_library-plus'
  | 'settings-tools_lightbulb'
  | 'settings-tools_link-break'
  | 'settings-tools_link-minus'
  | 'settings-tools_link-plus'
  | 'settings-tools_link-simple-h'
  | 'settings-tools_link-simple'
  | 'settings-tools_loader'
  | 'settings-tools_lock'
  | 'settings-tools_magnifying_glass-exclamation'
  | 'settings-tools_magnifying_glass-minus'
  | 'settings-tools_magnifying_glass-plus'
  | 'settings-tools_magnifying_glass-top-from_bracket'
  | 'settings-tools_magnifying_glass-triangle-down'
  | 'settings-tools_magnifying_glass-xmark'
  | 'settings-tools_magnifying_glass'
  | 'settings-tools_minus-circle-fill'
  | 'settings-tools_minus-circle'
  | 'settings-tools_minus'
  | 'settings-tools_moon'
  | 'settings-tools_paperclip-vertical'
  | 'settings-tools_paperclip'
  | 'settings-tools_pen-hammer'
  | 'settings-tools_pencil_arrow-right'
  | 'settings-tools_pencil_triangle-down'
  | 'settings-tools_pencil_triangle-left'
  | 'settings-tools_pencil-line-bottom'
  | 'settings-tools_pencil'
  | 'settings-tools_pipette'
  | 'settings-tools_plus'
  | 'settings-tools_power'
  | 'settings-tools_shield-exclamation'
  | 'settings-tools_shield-slash'
  | 'settings-tools_shield'
  | 'settings-tools_sliders-h'
  | 'settings-tools_sliders-v'
  | 'settings-tools_sun'
  | 'settings-tools_trash-empty'
  | 'settings-tools_trash'
  | 'settings-tools_unlock'
  | 'settings-tools_wrench'
  | 'settings-tools_xmark-mini'
  | 'settings-tools_xmark'
  | 'shape-geometry_arrange-send-to-back'
  | 'shape-geometry_checkerboard'
  | 'shape-geometry_circle_square-in-square'
  | 'shape-geometry_circle_square-fill-1'
  | 'shape-geometry_circle_square-fill'
  | 'shape-geometry_circle-in-hexagon'
  | 'shape-geometry_circles-line-left-up_circle-right-down-fill'
  | 'shape-geometry_circles-line-left-up_circle-right-down'
  | 'shape-geometry_collector'
  | 'shape-geometry_discrete-set'
  | 'shape-geometry_hexagon-fill'
  | 'shape-geometry_hexagon'
  | 'shape-geometry_pentagon-fill'
  | 'shape-geometry_pentagon'
  | 'shape-geometry_rhombus-fill'
  | 'shape-geometry_rhombus'
  | 'shape-geometry_ring-in-square'
  | 'shape-geometry_shape-4-f'
  | 'shape-geometry_shape-4'
  | 'shape-geometry_shape-6'
  | 'shape-geometry_shape-7'
  | 'shape-geometry_shape-plus'
  | 'shape-geometry_square_circle_plus_triangle-fill'
  | 'shape-geometry_square_circle_triangle_cross-fill'
  | 'shape-geometry_square_circle_triangle_cross'
  | 'shape-geometry_square_hexagon_circle-fill'
  | 'shape-geometry_square_hexagon_circle'
  | 'shape-geometry_square_triangle_circle_triangle-fill-1'
  | 'shape-geometry_square_triangle_circle_triangle-fill'
  | 'shape-geometry_square-in_square'
  | 'shape-geometry_triangle_circle_square-fill-1'
  | 'shape-geometry_triangle_circle_square-fill'
  | 'shape-geometry_triangle-fill'
  | 'shape-geometry_triangle'
  | 'user-account_user-arrows_swap'
  | 'user-account_user-card'
  | 'user-account_user-check'
  | 'user-account_user-circle'
  | 'user-account_user-cross'
  | 'user-account_user-gear'
  | 'user-account_user-location'
  | 'user-account_user-minus'
  | 'user-account_user-pen'
  | 'user-account_user-plus'
  | 'user-account_user-shield'
  | 'user-account_user-worker'
  | 'user-account_user'
  | 'user-account_users-arrow_right'
  | 'user-account_users-gear'
  | 'user-account_users-key'
  | 'user-account_users-location'
  | 'user-account_users-minus'
  | 'user-account_users-plus'
  | 'user-account_users';

export type PrizmIconSvgsKey =
  | 'ChartsDiagramsBarAxis'
  | 'ChartsDiagramsBarBasic'
  | 'ChartsDiagramsBarColumnsAxisX'
  | 'ChartsDiagramsBarColumns'
  | 'ChartsDiagramsBarSquare'
  | 'ChartsDiagramsBarStackedAxis'
  | 'ChartsDiagramsBarStacked'
  | 'ChartsDiagramsChartsHistogramChartDashed'
  | 'ChartsDiagramsColumn'
  | 'ChartsDiagramsDoughnut'
  | 'ChartsDiagramsGantt'
  | 'ChartsDiagramsGauge'
  | 'ChartsDiagramsHexagonAxis'
  | 'ChartsDiagramsHexagon'
  | 'ChartsDiagramsHistogramAxis'
  | 'ChartsDiagramsLineAxisX'
  | 'ChartsDiagramsLineAxisArrowDown'
  | 'ChartsDiagramsLineAxis'
  | 'ChartsDiagramsLineDown'
  | 'ChartsDiagramsLineMultipleYAxisX'
  | 'ChartsDiagramsLineMultipleYAxis'
  | 'ChartsDiagramsLineUp'
  | 'ChartsDiagramsLine'
  | 'ChartsDiagramsPieLineNested'
  | 'ChartsDiagramsPieLine'
  | 'ChartsDiagramsPiePentagon'
  | 'ChartsDiagramsPieSeveralParts'
  | 'ChartsDiagramsPieSimple'
  | 'ChartsDiagramsPie'
  | 'ChartsDiagramsRange'
  | 'ChartsDiagramsScatterAxis'
  | 'ChartsDiagramsScatterBasic'
  | 'ChartsDiagramsScatter'
  | 'CommunicationConnectionAtSign'
  | 'CommunicationConnectionBluetooth'
  | 'CommunicationConnectionBubbleMessageAdd'
  | 'CommunicationConnectionBubbleMessageAttention'
  | 'CommunicationConnectionBubbleMessageCircle'
  | 'CommunicationConnectionBubbleMessageEmpty'
  | 'CommunicationConnectionBubbleMessageOff'
  | 'CommunicationConnectionBubbleMessageQuestion'
  | 'CommunicationConnectionBubbleMessageText'
  | 'CommunicationConnectionBubbleMessage'
  | 'CommunicationConnectionHeadphones'
  | 'CommunicationConnectionHeartEmpty'
  | 'CommunicationConnectionHeartFill'
  | 'CommunicationConnectionMailOpen'
  | 'CommunicationConnectionMail'
  | 'CommunicationConnectionMailbox'
  | 'CommunicationConnectionMessagingTelegramSend'
  | 'CommunicationConnectionMessagingTelegram'
  | 'CommunicationConnectionPhoneActiveCall'
  | 'CommunicationConnectionPhoneCancelled'
  | 'CommunicationConnectionPhoneMinus'
  | 'CommunicationConnectionPhoneOff'
  | 'CommunicationConnectionPhonePaused'
  | 'CommunicationConnectionPhonePlus'
  | 'CommunicationConnectionPhone'
  | 'CommunicationConnectionShareLeft'
  | 'CommunicationConnectionShareRight'
  | 'CommunicationConnectionShareing'
  | 'CommunicationConnectionSignalAccessPoint'
  | 'CommunicationConnectionSignalOff'
  | 'CommunicationConnectionSignalRadioTower'
  | 'CommunicationConnectionSignal'
  | 'CommunicationConnectionStarEmpty'
  | 'CommunicationConnectionStarFill'
  | 'CommunicationConnectionStarHalfFill'
  | 'CommunicationConnectionSupportMan'
  | 'CommunicationConnectionThumbDown'
  | 'CommunicationConnectionThumbUp'
  | 'CommunicationConnectionWifiOff'
  | 'CommunicationConnectionWifi'
  | 'DataNetworkDatabaseChek'
  | 'DataNetworkDatabaseJson'
  | 'DataNetworkDatabaseMagnifyingGlass'
  | 'DataNetworkDatabaseMinus'
  | 'DataNetworkDatabasePlus'
  | 'DataNetworkDatabaseSql'
  | 'DataNetworkDatabaseXmark'
  | 'DataNetworkDatabase'
  | 'DataNetworkEthernet'
  | 'DataNetworkLanConnect'
  | 'DataNetworkLanDisconnect'
  | 'DataNetworkLanPending'
  | 'DataNetworkNetwork_1'
  | 'DataNetworkNetwork_2'
  | 'DataNetworkNetwork_3'
  | 'DataNetworkNetworkWired'
  | 'DataNetworkServerClose'
  | 'DataNetworkServerDownload'
  | 'DataNetworkServerMinus'
  | 'DataNetworkServerOne'
  | 'DataNetworkServerPlus'
  | 'DataNetworkServerSecurity'
  | 'DataNetworkServerShield'
  | 'DataNetworkServerSlashUpLine'
  | 'DataNetworkServerSlash'
  | 'DataNetworkServerUpLine'
  | 'DataNetworkServerUpload'
  | 'DataNetworkServer'
  | 'DateTimeAlarmClock'
  | 'DateTimeAlarmPlus'
  | 'DateTimeCalendarBlank'
  | 'DateTimeCalendarCheck'
  | 'DateTimeCalendarClock'
  | 'DateTimeCalendarDeleted'
  | 'DateTimeCalendarEvent'
  | 'DateTimeCalendarPlus'
  | 'DateTimeCalendarQuestion'
  | 'DateTimeCalendarRange'
  | 'DateTimeCalendarToday'
  | 'DateTimeCalendar'
  | 'DateTimeClockAdd'
  | 'DateTimeClockArrowDown'
  | 'DateTimeClockArrowRight'
  | 'DateTimeClockArrowUp'
  | 'DateTimeClockDeleted'
  | 'DateTimeClockExclamation'
  | 'DateTimeClockLineEnd'
  | 'DateTimeClockRotateLeft'
  | 'DateTimeClockRotateRight'
  | 'DateTimeClock'
  | 'DateTimeLetterDay'
  | 'DateTimeLetterHour'
  | 'DateTimeLetterMinute'
  | 'DateTimeLetterMonth'
  | 'DateTimeLetterSecond'
  | 'DateTimeLetterTime'
  | 'DateTimeLetterYear'
  | 'DateTimeSandglass'
  | 'DateTimeStopwatch'
  | 'DateTimeSumbolAsterisk'
  | 'DocumentsFoldersBookStack'
  | 'DocumentsFoldersBoxOpenArrowDown'
  | 'DocumentsFoldersBox'
  | 'DocumentsFoldersCloudArrowDown'
  | 'DocumentsFoldersCloudArrowUpInside'
  | 'DocumentsFoldersCloudArrowUp'
  | 'DocumentsFoldersCloudCheck'
  | 'DocumentsFoldersCloud'
  | 'DocumentsFoldersCollection_2'
  | 'DocumentsFoldersFileArrowDownLeft'
  | 'DocumentsFoldersFileArrowDown'
  | 'DocumentsFoldersFileArrowUp'
  | 'DocumentsFoldersFileArrow'
  | 'DocumentsFoldersFileArrowsUpRight'
  | 'DocumentsFoldersFileCamera'
  | 'DocumentsFoldersFileCrossOut'
  | 'DocumentsFoldersFileCross'
  | 'DocumentsFoldersFileDoc'
  | 'DocumentsFoldersFileDocx'
  | 'DocumentsFoldersFileDot'
  | 'DocumentsFoldersFileEmpty'
  | 'DocumentsFoldersFileExclamatio'
  | 'DocumentsFoldersFileEye'
  | 'DocumentsFoldersFileFilled'
  | 'DocumentsFoldersFileImage'
  | 'DocumentsFoldersFileMagnifyingGlass'
  | 'DocumentsFoldersFileMinus'
  | 'DocumentsFoldersFilePdf'
  | 'DocumentsFoldersFilePen'
  | 'DocumentsFoldersFilePlay'
  | 'DocumentsFoldersFilePlus'
  | 'DocumentsFoldersFilePpt'
  | 'DocumentsFoldersFilePptx'
  | 'DocumentsFoldersFileTxt'
  | 'DocumentsFoldersFileUpRight'
  | 'DocumentsFoldersFileXls'
  | 'DocumentsFoldersFileXlsx'
  | 'DocumentsFoldersFloppyCrossOut'
  | 'DocumentsFoldersFloppyCross'
  | 'DocumentsFoldersFloppyPen'
  | 'DocumentsFoldersFloppyStar'
  | 'DocumentsFoldersFloppy'
  | 'DocumentsFoldersFolderArrowDownLeft'
  | 'DocumentsFoldersFolderArrowDown'
  | 'DocumentsFoldersFolderArrowUpRight'
  | 'DocumentsFoldersFolderCross'
  | 'DocumentsFoldersFolderDot'
  | 'DocumentsFoldersFolderMinus'
  | 'DocumentsFoldersFolderPlus'
  | 'DocumentsFoldersFolderOpen'
  | 'DocumentsFoldersFolderUnderlineMinus'
  | 'DocumentsFoldersFolderUnderlinePlus'
  | 'DocumentsFoldersFolderUnderline'
  | 'DocumentsFoldersFolder'
  | 'DocumentsFoldersListSquare'
  | 'DocumentsFoldersListTreeArchive'
  | 'DocumentsFoldersListTree'
  | 'DocumentsFoldersList'
  | 'DocumentsFoldersOntology'
  | 'DocumentsFoldersSpecification'
  | 'DocumentsFoldersSquareArrowsCurveRightDown'
  | 'DocumentsFoldersSquareArrowsCurveUpRight'
  | 'DocumentsFoldersSquareExcel'
  | 'DocumentsFoldersSquarePowerpoint'
  | 'DocumentsFoldersSquareWord'
  | 'DocumentsFoldersTablet'
  | 'EditorDecorAgendaFill'
  | 'EditorDecorAlignBottom'
  | 'EditorDecorAlignCenterH'
  | 'EditorDecorAlignCenterV'
  | 'EditorDecorAlignCenter'
  | 'EditorDecorAlignJustify'
  | 'EditorDecorAlignLeft'
  | 'EditorDecorAlignRight'
  | 'EditorDecorAlignTop'
  | 'EditorDecorArrayFill'
  | 'EditorDecorBarsSort'
  | 'EditorDecorBdrvAdministration'
  | 'EditorDecorBezierCurve'
  | 'EditorDecorBold'
  | 'EditorDecorBorderAll'
  | 'EditorDecorBorderBottom'
  | 'EditorDecorBorderCenterH'
  | 'EditorDecorBorderCenterV'
  | 'EditorDecorBorderInner'
  | 'EditorDecorBorderLeft'
  | 'EditorDecorBorderNone'
  | 'EditorDecorBorderOuter'
  | 'EditorDecorBorderRight'
  | 'EditorDecorBorderTopLeft'
  | 'EditorDecorBorderTop'
  | 'EditorDecorBracketsCurly'
  | 'EditorDecorBracketsSquare'
  | 'EditorDecorBroom'
  | 'EditorDecorBrowser'
  | 'EditorDecorBrush'
  | 'EditorDecorCarouselFill'
  | 'EditorDecorCodeDownload'
  | 'EditorDecorCodeSimple'
  | 'EditorDecorCode'
  | 'EditorDecorCollageFill'
  | 'EditorDecorColumnFill'
  | 'EditorDecorComponent'
  | 'EditorDecorCopyColumn'
  | 'EditorDecorCopyRow'
  | 'EditorDecorCrop'
  | 'EditorDecorDashboardFill'
  | 'EditorDecorDashboardVariantFill'
  | 'EditorDecorDayFill'
  | 'EditorDecorEraser'
  | 'EditorDecorFill'
  | 'EditorDecorFunction'
  | 'EditorDecorGridFill'
  | 'EditorDecorGrid'
  | 'EditorDecorHashtag'
  | 'EditorDecorHeadlineFill'
  | 'EditorDecorIndentArrowLeft'
  | 'EditorDecorIndentArrowRight'
  | 'EditorDecorItalic'
  | 'EditorDecorKeyboardClose'
  | 'EditorDecorKeyboard'
  | 'EditorDecorLayerGroupSlash'
  | 'EditorDecorLayerGroup'
  | 'EditorDecorLineHeight'
  | 'EditorDecorListFill'
  | 'EditorDecorListOl'
  | 'EditorDecorListUl'
  | 'EditorDecorMagicWand'
  | 'EditorDecorModuleFill'
  | 'EditorDecorNpm'
  | 'EditorDecorObjectDownSubtract'
  | 'EditorDecorObjectExclude'
  | 'EditorDecorObjectIntersect'
  | 'EditorDecorObjectSelection'
  | 'EditorDecorObjectUnion'
  | 'EditorDecorObjectUpSubtract'
  | 'EditorDecorObject'
  | 'EditorDecorPalette'
  | 'EditorDecorPanelDown'
  | 'EditorDecorPanelLeft'
  | 'EditorDecorPanelRight'
  | 'EditorDecorPanelTop'
  | 'EditorDecorPantone'
  | 'EditorDecorPercent'
  | 'EditorDecorPi'
  | 'EditorDecorPlusColumnRight'
  | 'EditorDecorPlusColumnTop'
  | 'EditorDecorPolyline'
  | 'EditorDecorQuiltFill'
  | 'EditorDecorRuler'
  | 'EditorDecorScissors'
  | 'EditorDecorSendBackward'
  | 'EditorDecorSendForward'
  | 'EditorDecorSequentialFill'
  | 'EditorDecorShovel'
  | 'EditorDecorSigma'
  | 'EditorDecorSquareBracketCurlyRight_1'
  | 'EditorDecorSquareBracketCurlyRight'
  | 'EditorDecorSquareBracketLeft'
  | 'EditorDecorSquareBracketRight'
  | 'EditorDecorSquareDivide'
  | 'EditorDecorSquareMinus'
  | 'EditorDecorSquareMultiply'
  | 'EditorDecorSquarePercent'
  | 'EditorDecorSquarePlus'
  | 'EditorDecorStarLine'
  | 'EditorDecorStrikethrough'
  | 'EditorDecorSubskritDown'
  | 'EditorDecorSubskritUp'
  | 'EditorDecorTableDown'
  | 'EditorDecorTableMagnifyingGlass'
  | 'EditorDecorTableRight'
  | 'EditorDecorTableTranspose'
  | 'EditorDecorTable'
  | 'EditorDecorTextColor'
  | 'EditorDecorText'
  | 'EditorDecorUnderlined'
  | 'EditorDecorVectorCircleOnePoint'
  | 'EditorDecorVectorCircleTwoPoint'
  | 'EditorDecorVectorCircle'
  | 'EditorDecorVectorLine'
  | 'EditorDecorVectorPoint'
  | 'EditorDecorVectorPolygon'
  | 'EditorDecorVectorRectangle'
  | 'EditorDecorVectorSquare'
  | 'EditorDecorVectorTriangle'
  | 'EditorDecorVectorsRadius'
  | 'EditorDecorWindow'
  | 'EditorDecorXmarkColumnRight'
  | 'EditorDecorXmarkColumnTop'
  | 'LogisticsTransportationAirplaneSideView'
  | 'LogisticsTransportationAirplaneTopView'
  | 'LogisticsTransportationAmbulanceSideView'
  | 'LogisticsTransportationCarJeepSideView'
  | 'LogisticsTransportationCarLightSideView'
  | 'LogisticsTransportationConcreteMixerSideView'
  | 'LogisticsTransportationHelicopterSideView'
  | 'LogisticsTransportationMinibusSideView'
  | 'LogisticsTransportationPaverSideView'
  | 'LogisticsTransportationPipeNodeSideView'
  | 'LogisticsTransportationRailcarHopperSideView'
  | 'LogisticsTransportationRailcarSideView'
  | 'LogisticsTransportationShipFrontView'
  | 'LogisticsTransportationShipSideView'
  | 'LogisticsTransportationTankcarOilSideView'
  | 'LogisticsTransportationTankcarSideView'
  | 'LogisticsTransportationTruckDumpSideView'
  | 'LogisticsTransportationTruckEmptySideView'
  | 'LogisticsTransportationTruckGarbageSideView'
  | 'LogisticsTransportationTruckGasolineSideView'
  | 'LogisticsTransportationTruckSideView'
  | 'MapLocationCompass'
  | 'MapLocationCrosshairsDot'
  | 'MapLocationCrosshairsSimple'
  | 'MapLocationLocationArrow'
  | 'MapLocationLocationDirectly'
  | 'MapLocationLocationDot'
  | 'MapLocationLocationMinus'
  | 'MapLocationLocationPlus'
  | 'MapLocationLocationSlash'
  | 'MapLocationLocationUser'
  | 'MapLocationMapBase'
  | 'MapLocationMapPin'
  | 'MapLocationMap'
  | 'MapLocationThumbtackDirectly'
  | 'MapLocationThumbtack'
  | 'MapLocationWorld_2'
  | 'MapLocationWorld'
  | 'MultimediaDevicesAndroidPill'
  | 'MultimediaDevicesAndroid'
  | 'MultimediaDevicesAudioSpeakers'
  | 'MultimediaDevicesBookmarkMusic'
  | 'MultimediaDevicesCameraFront'
  | 'MultimediaDevicesCameraMovieCross'
  | 'MultimediaDevicesCameraMovie'
  | 'MultimediaDevicesCamera'
  | 'MultimediaDevicesCellphoneWireless'
  | 'MultimediaDevicesCellphone'
  | 'MultimediaDevicesCircleMusic'
  | 'MultimediaDevicesClapperboardCross'
  | 'MultimediaDevicesClapperboardOpen'
  | 'MultimediaDevicesDesktopTower'
  | 'MultimediaDevicesFileMusic'
  | 'MultimediaDevicesFilmCross'
  | 'MultimediaDevicesFilm'
  | 'MultimediaDevicesForvardStep'
  | 'MultimediaDevicesForward'
  | 'MultimediaDevicesHardDriveOutline'
  | 'MultimediaDevicesImage'
  | 'MultimediaDevicesInfinity'
  | 'MultimediaDevicesInputDevice'
  | 'MultimediaDevicesLaptopPhoneSlash'
  | 'MultimediaDevicesLaptopPhone'
  | 'MultimediaDevicesLaptopSlash'
  | 'MultimediaDevicesLaptop'
  | 'MultimediaDevicesMicrophoneSlash'
  | 'MultimediaDevicesMicrophone'
  | 'MultimediaDevicesMonitor'
  | 'MultimediaDevicesMusicSlash'
  | 'MultimediaDevicesMusic'
  | 'MultimediaDevicesPause'
  | 'MultimediaDevicesPlayBack'
  | 'MultimediaDevicesPlay'
  | 'MultimediaDevicesPrinter'
  | 'MultimediaDevicesPushButtonCellphone'
  | 'MultimediaDevicesReturnStep'
  | 'MultimediaDevicesReturn'
  | 'MultimediaDevicesSquareMusicDouble'
  | 'MultimediaDevicesSquareMusic'
  | 'MultimediaDevicesStop'
  | 'MultimediaDevicesTablet'
  | 'MultimediaDevicesTouchpad'
  | 'MultimediaDevicesTransmitter'
  | 'MultimediaDevicesTv'
  | 'MultimediaDevicesVideoCross'
  | 'MultimediaDevicesVideoSlash'
  | 'MultimediaDevicesVideo'
  | 'MultimediaDevicesVoicemail'
  | 'MultimediaDevicesVolumeCross'
  | 'MultimediaDevicesVolumeLow'
  | 'MultimediaDevicesVolumeMinus'
  | 'MultimediaDevicesVolumeOff'
  | 'MultimediaDevicesVolumePlus'
  | 'MultimediaDevicesVolumeSlash'
  | 'MultimediaDevicesVolume'
  | 'MultimediaDevicesWatch'
  | 'MultimediaDevicesWebcam'
  | 'NotificationsAlertsBellFill'
  | 'NotificationsAlertsBellPlus'
  | 'NotificationsAlertsBellRingFill'
  | 'NotificationsAlertsBellRing'
  | 'NotificationsAlertsBellSlash'
  | 'NotificationsAlertsBell'
  | 'NotificationsAlertsCheckDouble'
  | 'NotificationsAlertsChek'
  | 'NotificationsAlertsCircleChekEmpty'
  | 'NotificationsAlertsCircleChekFill'
  | 'NotificationsAlertsCircleExclamationEmpty'
  | 'NotificationsAlertsCircleExclamationFill'
  | 'NotificationsAlertsCircleInfoEmpty'
  | 'NotificationsAlertsCircleInfoFill'
  | 'NotificationsAlertsCircleQuestionEmpty'
  | 'NotificationsAlertsCircleQuestionFill'
  | 'NotificationsAlertsDecagramChekEmpty'
  | 'NotificationsAlertsDecagramChekFill'
  | 'NotificationsAlertsDecagramExclamationEmpty'
  | 'NotificationsAlertsDecagramExclamationFill'
  | 'NotificationsAlertsExclamation'
  | 'NotificationsAlertsFlagFillRed'
  | 'NotificationsAlertsFlagFill'
  | 'NotificationsAlertsFlag'
  | 'NotificationsAlertsHexagonExclamationEmpty'
  | 'NotificationsAlertsHexagonExclamationFill'
  | 'NotificationsAlertsInfo'
  | 'NotificationsAlertsQuestion'
  | 'NotificationsAlertsSquareExclamationEmpty'
  | 'NotificationsAlertsSquareExclamationFill'
  | 'NotificationsAlertsSquareInfoEmpty'
  | 'NotificationsAlertsSquareInfoFill'
  | 'NotificationsAlertsSquareQuestionEmpty'
  | 'NotificationsAlertsSquareQuestionFill'
  | 'NotificationsAlertsTriangleCrossEmpty'
  | 'NotificationsAlertsTriangleExclamationEmpty'
  | 'NotificationsAlertsTriangleExclamationFill'
  | 'NotificationsAlertsTriangleInfoEmpty'
  | 'NotificationsAlertsTriangleInfoFill'
  | 'NotificationsAlertsTrianglePlusEmpty'
  | 'OtherAward'
  | 'OtherDefaultIco'
  | 'OtherFaceFrown'
  | 'OtherFaceSmile'
  | 'OtherGitLab'
  | 'OtherInstagram'
  | 'OtherLogoGreyZ'
  | 'OtherLogoSGrey'
  | 'OtherMapMarkerDate_1'
  | 'OtherMapMarkerDate_2'
  | 'OtherOwl'
  | 'OtherPortfel'
  | 'OtherTemperatureMinus'
  | 'OtherTemperaturePlus'
  | 'OtherTemperature'
  | 'OtherTemplate'
  | 'OtherUmbrella'
  | 'PowerEnergyBatteryBolt'
  | 'PowerEnergyBatteryEmpty'
  | 'PowerEnergyBatteryExclametionMark'
  | 'PowerEnergyBatteryFull'
  | 'PowerEnergyBatteryHalf'
  | 'PowerEnergyBatteryMinus'
  | 'PowerEnergyBatteryPlus'
  | 'PowerEnergyBatteryQuarter'
  | 'PowerEnergyBatteryThreeQuarters'
  | 'PowerEnergyEnergyCheck'
  | 'PowerEnergyEnergySlash'
  | 'PowerEnergyEnergy'
  | 'PowerEnergyPulse'
  | 'ProductionIndustryBalloon'
  | 'ProductionIndustryBoilerHotWaterGasAndOil'
  | 'ProductionIndustryBoiler'
  | 'ProductionIndustryBurn'
  | 'ProductionIndustryCarbon'
  | 'ProductionIndustryCartFlatbedContainer'
  | 'ProductionIndustryContainer_2'
  | 'ProductionIndustryContainer'
  | 'ProductionIndustryContainers'
  | 'ProductionIndustryCrane'
  | 'ProductionIndustryCubeEmpty'
  | 'ProductionIndustryCubeFill'
  | 'ProductionIndustryCubes'
  | 'ProductionIndustryEarlyVersion'
  | 'ProductionIndustryElectrics'
  | 'ProductionIndustryExchanger'
  | 'ProductionIndustryFactoryPipe'
  | 'ProductionIndustryFactoryPipes'
  | 'ProductionIndustryFactory'
  | 'ProductionIndustryFan'
  | 'ProductionIndustryFire'
  | 'ProductionIndustryFlaskRoundPotion'
  | 'ProductionIndustryFlask'
  | 'ProductionIndustryFuelOilTank'
  | 'ProductionIndustryGasMonitoring'
  | 'ProductionIndustryGasPump'
  | 'ProductionIndustryGas'
  | 'ProductionIndustryGearCooling'
  | 'ProductionIndustryGenerator'
  | 'ProductionIndustryLngStorage'
  | 'ProductionIndustryMedical'
  | 'ProductionIndustryNiFiLogo'
  | 'ProductionIndustryOilBarrel'
  | 'ProductionIndustryOilCanister'
  | 'ProductionIndustryOilDropletArrowsAll'
  | 'ProductionIndustryOilDropletArrowsRepeatH'
  | 'ProductionIndustryOilDropletChek'
  | 'ProductionIndustryOilDroplet'
  | 'ProductionIndustryOilField'
  | 'ProductionIndustryOilTank'
  | 'ProductionIndustryPipeSensor'
  | 'ProductionIndustryPipeValve'
  | 'ProductionIndustryPipeline_2'
  | 'ProductionIndustryPipeline'
  | 'ProductionIndustryPress'
  | 'ProductionIndustryPumpTriangleDown'
  | 'ProductionIndustryPump'
  | 'ProductionIndustryRadiation'
  | 'ProductionIndustryRespirator_1'
  | 'ProductionIndustryRespirator_2'
  | 'ProductionIndustryRespirator_3'
  | 'ProductionIndustryRespirator_4'
  | 'ProductionIndustryRespirator_5'
  | 'ProductionIndustryRespirator_6'
  | 'ProductionIndustrySeedlingCircle'
  | 'ProductionIndustrySeedlingRectangle'
  | 'ProductionIndustrySeedling'
  | 'ProductionIndustrySeparator'
  | 'ProductionIndustrySnakeCup'
  | 'ProductionIndustrySnowflakeUpToBracket'
  | 'ProductionIndustrySnowflake'
  | 'ProductionIndustrySpeedReductionCooling'
  | 'ProductionIndustrySteamBoiler'
  | 'ProductionIndustrySteamTurbine'
  | 'ProductionIndustrySteam'
  | 'ProductionIndustryTank_1'
  | 'ProductionIndustryTank'
  | 'ProductionIndustryVialArrowRotateLeft'
  | 'ProductionIndustryVialFlask'
  | 'ProductionIndustryVialXmark'
  | 'ProductionIndustryVial'
  | 'ProductionIndustryWaterHeater'
  | 'ProductionIndustryWaterPump'
  | 'SettingsToolsBan'
  | 'SettingsToolsBars'
  | 'SettingsToolsCirclePlusFill'
  | 'SettingsToolsCirclePlus'
  | 'SettingsToolsCircleXmarkFill'
  | 'SettingsToolsCircleXmark'
  | 'SettingsToolsCopy'
  | 'SettingsToolsDeleteContent'
  | 'SettingsToolsDropletSlash'
  | 'SettingsToolsDroplet'
  | 'SettingsToolsEllipsisGrid'
  | 'SettingsToolsEllipsisH'
  | 'SettingsToolsEllipsisV'
  | 'SettingsToolsEyeClosed'
  | 'SettingsToolsEyeSlash'
  | 'SettingsToolsEye'
  | 'SettingsToolsFilter'
  | 'SettingsToolsGear_5'
  | 'SettingsToolsGear_8'
  | 'SettingsToolsGripDotsVertical'
  | 'SettingsToolsHouseMini'
  | 'SettingsToolsHouse'
  | 'SettingsToolsKey'
  | 'SettingsToolsLibraryPlus'
  | 'SettingsToolsLightbulb'
  | 'SettingsToolsLinkBreak'
  | 'SettingsToolsLinkMinus'
  | 'SettingsToolsLinkPlus'
  | 'SettingsToolsLinkSimpleH'
  | 'SettingsToolsLinkSimple'
  | 'SettingsToolsLoader'
  | 'SettingsToolsLock'
  | 'SettingsToolsMagnifyingGlassExclamation'
  | 'SettingsToolsMagnifyingGlassMinus'
  | 'SettingsToolsMagnifyingGlassPlus'
  | 'SettingsToolsMagnifyingGlassTopFromBracket'
  | 'SettingsToolsMagnifyingGlassTriangleDown'
  | 'SettingsToolsMagnifyingGlassXmark'
  | 'SettingsToolsMagnifyingGlass'
  | 'SettingsToolsMinusCircleFill'
  | 'SettingsToolsMinusCircle'
  | 'SettingsToolsMinus'
  | 'SettingsToolsMoon'
  | 'SettingsToolsPaperclipVertical'
  | 'SettingsToolsPaperclip'
  | 'SettingsToolsPenHammer'
  | 'SettingsToolsPencilArrowRight'
  | 'SettingsToolsPencilTriangleDown'
  | 'SettingsToolsPencilTriangleLeft'
  | 'SettingsToolsPencilLineBottom'
  | 'SettingsToolsPencil'
  | 'SettingsToolsPipette'
  | 'SettingsToolsPlus'
  | 'SettingsToolsPower'
  | 'SettingsToolsShieldExclamation'
  | 'SettingsToolsShieldSlash'
  | 'SettingsToolsShield'
  | 'SettingsToolsSlidersH'
  | 'SettingsToolsSlidersV'
  | 'SettingsToolsSun'
  | 'SettingsToolsTrashEmpty'
  | 'SettingsToolsTrash'
  | 'SettingsToolsUnlock'
  | 'SettingsToolsWrench'
  | 'SettingsToolsXmarkMini'
  | 'SettingsToolsXmark'
  | 'ShapeGeometryArrangeSendToBack'
  | 'ShapeGeometryCheckerboard'
  | 'ShapeGeometryCircleSquareInSquare'
  | 'ShapeGeometryCircleSquareFill_1'
  | 'ShapeGeometryCircleSquareFill'
  | 'ShapeGeometryCircleInHexagon'
  | 'ShapeGeometryCirclesLineLeftUpCircleRightDownFill'
  | 'ShapeGeometryCirclesLineLeftUpCircleRightDown'
  | 'ShapeGeometryCollector'
  | 'ShapeGeometryDiscreteSet'
  | 'ShapeGeometryHexagonFill'
  | 'ShapeGeometryHexagon'
  | 'ShapeGeometryPentagonFill'
  | 'ShapeGeometryPentagon'
  | 'ShapeGeometryRhombusFill'
  | 'ShapeGeometryRhombus'
  | 'ShapeGeometryRingInSquare'
  | 'ShapeGeometryShape_4F'
  | 'ShapeGeometryShape_4'
  | 'ShapeGeometryShape_6'
  | 'ShapeGeometryShape_7'
  | 'ShapeGeometryShapePlus'
  | 'ShapeGeometrySquareCirclePlusTriangleFill'
  | 'ShapeGeometrySquareCircleTriangleCrossFill'
  | 'ShapeGeometrySquareCircleTriangleCross'
  | 'ShapeGeometrySquareHexagonCircleFill'
  | 'ShapeGeometrySquareHexagonCircle'
  | 'ShapeGeometrySquareTriangleCircleTriangleFill_1'
  | 'ShapeGeometrySquareTriangleCircleTriangleFill'
  | 'ShapeGeometrySquareInSquare'
  | 'ShapeGeometryTriangleCircleSquareFill_1'
  | 'ShapeGeometryTriangleCircleSquareFill'
  | 'ShapeGeometryTriangleFill'
  | 'ShapeGeometryTriangle'
  | 'UserAccountUserArrowsSwap'
  | 'UserAccountUserCard'
  | 'UserAccountUserCheck'
  | 'UserAccountUserCircle'
  | 'UserAccountUserCross'
  | 'UserAccountUserGear'
  | 'UserAccountUserLocation'
  | 'UserAccountUserMinus'
  | 'UserAccountUserPen'
  | 'UserAccountUserPlus'
  | 'UserAccountUserShield'
  | 'UserAccountUserWorker'
  | 'UserAccountUser'
  | 'UserAccountUsersArrowRight'
  | 'UserAccountUsersGear'
  | 'UserAccountUsersKey'
  | 'UserAccountUsersLocation'
  | 'UserAccountUsersMinus'
  | 'UserAccountUsersPlus'
  | 'UserAccountUsers';

export enum PrizmIconType {
  ChartsDiagramsBarAxis = 'charts-diagrams_bar-axis',
  ChartsDiagramsBarBasic = 'charts-diagrams_bar-basic',
  ChartsDiagramsBarColumnsAxisX = 'charts-diagrams_bar-columns-axis_x',
  ChartsDiagramsBarColumns = 'charts-diagrams_bar-columns',
  ChartsDiagramsBarSquare = 'charts-diagrams_bar-square',
  ChartsDiagramsBarStackedAxis = 'charts-diagrams_bar-stacked-axis',
  ChartsDiagramsBarStacked = 'charts-diagrams_bar-stacked',
  ChartsDiagramsChartsHistogramChartDashed = 'charts-diagrams_charts-histogram-chart-dashed',
  ChartsDiagramsColumn = 'charts-diagrams_column',
  ChartsDiagramsDoughnut = 'charts-diagrams_doughnut',
  ChartsDiagramsGantt = 'charts-diagrams_gantt',
  ChartsDiagramsGauge = 'charts-diagrams_gauge',
  ChartsDiagramsHexagonAxis = 'charts-diagrams_hexagon-axis',
  ChartsDiagramsHexagon = 'charts-diagrams_hexagon',
  ChartsDiagramsHistogramAxis = 'charts-diagrams_histogram-axis',
  ChartsDiagramsLineAxisX = 'charts-diagrams_line-axis_x',
  ChartsDiagramsLineAxisArrowDown = 'charts-diagrams_line-axis-arrow_down',
  ChartsDiagramsLineAxis = 'charts-diagrams_line-axis',
  ChartsDiagramsLineDown = 'charts-diagrams_line-down',
  ChartsDiagramsLineMultipleYAxisX = 'charts-diagrams_line-multiple_y_axis-x',
  ChartsDiagramsLineMultipleYAxis = 'charts-diagrams_line-multiple_y_axis',
  ChartsDiagramsLineUp = 'charts-diagrams_line-up',
  ChartsDiagramsLine = 'charts-diagrams_line',
  ChartsDiagramsPieLineNested = 'charts-diagrams_pie-line-nested',
  ChartsDiagramsPieLine = 'charts-diagrams_pie-line',
  ChartsDiagramsPiePentagon = 'charts-diagrams_pie-pentagon',
  ChartsDiagramsPieSeveralParts = 'charts-diagrams_pie-several_parts',
  ChartsDiagramsPieSimple = 'charts-diagrams_pie-simple',
  ChartsDiagramsPie = 'charts-diagrams_pie',
  ChartsDiagramsRange = 'charts-diagrams_range',
  ChartsDiagramsScatterAxis = 'charts-diagrams_scatter-axis',
  ChartsDiagramsScatterBasic = 'charts-diagrams_scatter-basic',
  ChartsDiagramsScatter = 'charts-diagrams_scatter',
  CommunicationConnectionAtSign = 'communication-connection_at-sign',
  CommunicationConnectionBluetooth = 'communication-connection_bluetooth',
  CommunicationConnectionBubbleMessageAdd = 'communication-connection_bubble-message-add',
  CommunicationConnectionBubbleMessageAttention = 'communication-connection_bubble-message-attention',
  CommunicationConnectionBubbleMessageCircle = 'communication-connection_bubble-message-circle',
  CommunicationConnectionBubbleMessageEmpty = 'communication-connection_bubble-message-empty',
  CommunicationConnectionBubbleMessageOff = 'communication-connection_bubble-message-off',
  CommunicationConnectionBubbleMessageQuestion = 'communication-connection_bubble-message-question',
  CommunicationConnectionBubbleMessageText = 'communication-connection_bubble-message-text',
  CommunicationConnectionBubbleMessage = 'communication-connection_bubble-message',
  CommunicationConnectionHeadphones = 'communication-connection_headphones',
  CommunicationConnectionHeartEmpty = 'communication-connection_heart-empty',
  CommunicationConnectionHeartFill = 'communication-connection_heart-fill',
  CommunicationConnectionMailOpen = 'communication-connection_mail-open',
  CommunicationConnectionMail = 'communication-connection_mail',
  CommunicationConnectionMailbox = 'communication-connection_mailbox',
  CommunicationConnectionMessagingTelegramSend = 'communication-connection_messaging-telegram-send',
  CommunicationConnectionMessagingTelegram = 'communication-connection_messaging-telegram',
  CommunicationConnectionPhoneActiveCall = 'communication-connection_phone-active-call',
  CommunicationConnectionPhoneCancelled = 'communication-connection_phone-cancelled',
  CommunicationConnectionPhoneMinus = 'communication-connection_phone-minus',
  CommunicationConnectionPhoneOff = 'communication-connection_phone-off',
  CommunicationConnectionPhonePaused = 'communication-connection_phone-paused',
  CommunicationConnectionPhonePlus = 'communication-connection_phone-plus',
  CommunicationConnectionPhone = 'communication-connection_phone',
  CommunicationConnectionShareLeft = 'communication-connection_share-left',
  CommunicationConnectionShareRight = 'communication-connection_share-right',
  CommunicationConnectionShareing = 'communication-connection_shareing',
  CommunicationConnectionSignalAccessPoint = 'communication-connection_signal-access-point',
  CommunicationConnectionSignalOff = 'communication-connection_signal-off',
  CommunicationConnectionSignalRadioTower = 'communication-connection_signal-radio-tower',
  CommunicationConnectionSignal = 'communication-connection_signal',
  CommunicationConnectionStarEmpty = 'communication-connection_star-empty',
  CommunicationConnectionStarFill = 'communication-connection_star-fill',
  CommunicationConnectionStarHalfFill = 'communication-connection_star-half-fill',
  CommunicationConnectionSupportMan = 'communication-connection_support-man',
  CommunicationConnectionThumbDown = 'communication-connection_thumb-down',
  CommunicationConnectionThumbUp = 'communication-connection_thumb-up',
  CommunicationConnectionWifiOff = 'communication-connection_wifi-off',
  CommunicationConnectionWifi = 'communication-connection_wifi',
  DataNetworkDatabaseChek = 'data-network_database-chek',
  DataNetworkDatabaseJson = 'data-network_database-json',
  DataNetworkDatabaseMagnifyingGlass = 'data-network_database-magnifying_glass',
  DataNetworkDatabaseMinus = 'data-network_database-minus',
  DataNetworkDatabasePlus = 'data-network_database-plus',
  DataNetworkDatabaseSql = 'data-network_database-sql',
  DataNetworkDatabaseXmark = 'data-network_database-xmark',
  DataNetworkDatabase = 'data-network_database',
  DataNetworkEthernet = 'data-network_ethernet',
  DataNetworkLanConnect = 'data-network_lan-connect',
  DataNetworkLanDisconnect = 'data-network_lan-disconnect',
  DataNetworkLanPending = 'data-network_lan-pending',
  DataNetworkNetwork_1 = 'data-network_network-1',
  DataNetworkNetwork_2 = 'data-network_network-2',
  DataNetworkNetwork_3 = 'data-network_network-3',
  DataNetworkNetworkWired = 'data-network_network-wired',
  DataNetworkServerClose = 'data-network_server-close',
  DataNetworkServerDownload = 'data-network_server-download',
  DataNetworkServerMinus = 'data-network_server-minus',
  DataNetworkServerOne = 'data-network_server-one',
  DataNetworkServerPlus = 'data-network_server-plus',
  DataNetworkServerSecurity = 'data-network_server-security',
  DataNetworkServerShield = 'data-network_server-shield',
  DataNetworkServerSlashUpLine = 'data-network_server-slash-up-line',
  DataNetworkServerSlash = 'data-network_server-slash',
  DataNetworkServerUpLine = 'data-network_server-up-line',
  DataNetworkServerUpload = 'data-network_server-upload',
  DataNetworkServer = 'data-network_server',
  DateTimeAlarmClock = 'date-time_alarm-clock',
  DateTimeAlarmPlus = 'date-time_alarm-plus',
  DateTimeCalendarBlank = 'date-time_calendar-blank',
  DateTimeCalendarCheck = 'date-time_calendar-check',
  DateTimeCalendarClock = 'date-time_calendar-clock',
  DateTimeCalendarDeleted = 'date-time_calendar-deleted',
  DateTimeCalendarEvent = 'date-time_calendar-event',
  DateTimeCalendarPlus = 'date-time_calendar-plus',
  DateTimeCalendarQuestion = 'date-time_calendar-question',
  DateTimeCalendarRange = 'date-time_calendar-range',
  DateTimeCalendarToday = 'date-time_calendar-today',
  DateTimeCalendar = 'date-time_calendar',
  DateTimeClockAdd = 'date-time_clock-add',
  DateTimeClockArrowDown = 'date-time_clock-arrow-down',
  DateTimeClockArrowRight = 'date-time_clock-arrow-right',
  DateTimeClockArrowUp = 'date-time_clock-arrow-up',
  DateTimeClockDeleted = 'date-time_clock-deleted',
  DateTimeClockExclamation = 'date-time_clock-exclamation',
  DateTimeClockLineEnd = 'date-time_clock-line-end',
  DateTimeClockRotateLeft = 'date-time_clock-rotate-left',
  DateTimeClockRotateRight = 'date-time_clock-rotate-right',
  DateTimeClock = 'date-time_clock',
  DateTimeLetterDay = 'date-time_letter-day',
  DateTimeLetterHour = 'date-time_letter-hour',
  DateTimeLetterMinute = 'date-time_letter-minute',
  DateTimeLetterMonth = 'date-time_letter-month',
  DateTimeLetterSecond = 'date-time_letter-second',
  DateTimeLetterTime = 'date-time_letter-time',
  DateTimeLetterYear = 'date-time_letter-year',
  DateTimeSandglass = 'date-time_sandglass',
  DateTimeStopwatch = 'date-time_stopwatch',
  DateTimeSumbolAsterisk = 'date-time_sumbol-asterisk',
  DocumentsFoldersBookStack = 'documents-folders_book_stack',
  DocumentsFoldersBoxOpenArrowDown = 'documents-folders_box-open-arrow-down',
  DocumentsFoldersBox = 'documents-folders_box',
  DocumentsFoldersCloudArrowDown = 'documents-folders_cloud_arrow_down',
  DocumentsFoldersCloudArrowUpInside = 'documents-folders_cloud_arrow_up_inside',
  DocumentsFoldersCloudArrowUp = 'documents-folders_cloud_arrow_up',
  DocumentsFoldersCloudCheck = 'documents-folders_cloud_check',
  DocumentsFoldersCloud = 'documents-folders_cloud',
  DocumentsFoldersCollection_2 = 'documents-folders_collection-2',
  DocumentsFoldersFileArrowDownLeft = 'documents-folders_file_arrow_down_left',
  DocumentsFoldersFileArrowDown = 'documents-folders_file_arrow_down',
  DocumentsFoldersFileArrowUp = 'documents-folders_file_arrow_up',
  DocumentsFoldersFileArrow = 'documents-folders_file_arrow',
  DocumentsFoldersFileArrowsUpRight = 'documents-folders_file_arrows_up_right',
  DocumentsFoldersFileCamera = 'documents-folders_file_camera',
  DocumentsFoldersFileCrossOut = 'documents-folders_file_cross_out',
  DocumentsFoldersFileCross = 'documents-folders_file_cross',
  DocumentsFoldersFileDoc = 'documents-folders_file_doc',
  DocumentsFoldersFileDocx = 'documents-folders_file_docx',
  DocumentsFoldersFileDot = 'documents-folders_file_dot',
  DocumentsFoldersFileEmpty = 'documents-folders_file_empty',
  DocumentsFoldersFileExclamatio = 'documents-folders_file-exclamatio',
  DocumentsFoldersFileEye = 'documents-folders_file_eye',
  DocumentsFoldersFileFilled = 'documents-folders_file_filled',
  DocumentsFoldersFileImage = 'documents-folders_file_image',
  DocumentsFoldersFileMagnifyingGlass = 'documents-folders_file_magnifying_glass',
  DocumentsFoldersFileMinus = 'documents-folders_file_minus',
  DocumentsFoldersFilePdf = 'documents-folders_file_pdf',
  DocumentsFoldersFilePen = 'documents-folders_file_pen',
  DocumentsFoldersFilePlay = 'documents-folders_file_play',
  DocumentsFoldersFilePlus = 'documents-folders_file_plus',
  DocumentsFoldersFilePpt = 'documents-folders_file_ppt',
  DocumentsFoldersFilePptx = 'documents-folders_file_pptx',
  DocumentsFoldersFileTxt = 'documents-folders_file_txt',
  DocumentsFoldersFileUpRight = 'documents-folders_file_up_right',
  DocumentsFoldersFileXls = 'documents-folders_file_xls',
  DocumentsFoldersFileXlsx = 'documents-folders_file_xlsx',
  DocumentsFoldersFloppyCrossOut = 'documents-folders_floppy_cross_out',
  DocumentsFoldersFloppyCross = 'documents-folders_floppy_cross',
  DocumentsFoldersFloppyPen = 'documents-folders_floppy_pen',
  DocumentsFoldersFloppyStar = 'documents-folders_floppy_star',
  DocumentsFoldersFloppy = 'documents-folders_floppy',
  DocumentsFoldersFolderArrowDownLeft = 'documents-folders_folder_arrow_down_left',
  DocumentsFoldersFolderArrowDown = 'documents-folders_folder_arrow_down',
  DocumentsFoldersFolderArrowUpRight = 'documents-folders_folder_arrow_up_right',
  DocumentsFoldersFolderCross = 'documents-folders_folder_cross',
  DocumentsFoldersFolderDot = 'documents-folders_folder_dot',
  DocumentsFoldersFolderMinus = 'documents-folders_folder_minus',
  DocumentsFoldersFolderPlus = 'documents-folders_folder_plus',
  DocumentsFoldersFolderOpen = 'documents-folders_folder_open',
  DocumentsFoldersFolderUnderlineMinus = 'documents-folders_folder_underline_minus',
  DocumentsFoldersFolderUnderlinePlus = 'documents-folders_folder_underline_plus',
  DocumentsFoldersFolderUnderline = 'documents-folders_folder_underline',
  DocumentsFoldersFolder = 'documents-folders_folder',
  DocumentsFoldersListSquare = 'documents-folders_list_square',
  DocumentsFoldersListTreeArchive = 'documents-folders_list-tree-archive',
  DocumentsFoldersListTree = 'documents-folders_list-tree',
  DocumentsFoldersList = 'documents-folders_list',
  DocumentsFoldersOntology = 'documents-folders_ontology',
  DocumentsFoldersSpecification = 'documents-folders_specification',
  DocumentsFoldersSquareArrowsCurveRightDown = 'documents-folders_square_arrows_curve_right_down',
  DocumentsFoldersSquareArrowsCurveUpRight = 'documents-folders_square_arrows_curve_up_right',
  DocumentsFoldersSquareExcel = 'documents-folders_square_excel',
  DocumentsFoldersSquarePowerpoint = 'documents-folders_square_powerpoint',
  DocumentsFoldersSquareWord = 'documents-folders_square_word',
  DocumentsFoldersTablet = 'documents-folders_tablet',
  EditorDecorAgendaFill = 'editor-decor_agenda-fill',
  EditorDecorAlignBottom = 'editor-decor_align-bottom',
  EditorDecorAlignCenterH = 'editor-decor_align-center-h',
  EditorDecorAlignCenterV = 'editor-decor_align-center-v',
  EditorDecorAlignCenter = 'editor-decor_align-center',
  EditorDecorAlignJustify = 'editor-decor_align-justify',
  EditorDecorAlignLeft = 'editor-decor_align-left',
  EditorDecorAlignRight = 'editor-decor_align-right',
  EditorDecorAlignTop = 'editor-decor_align-top',
  EditorDecorArrayFill = 'editor-decor_array-fill',
  EditorDecorBarsSort = 'editor-decor_bars-sort',
  EditorDecorBdrvAdministration = 'editor-decor_bdrv-administration',
  EditorDecorBezierCurve = 'editor-decor_bezier-curve',
  EditorDecorBold = 'editor-decor_bold',
  EditorDecorBorderAll = 'editor-decor_border-all',
  EditorDecorBorderBottom = 'editor-decor_border-bottom',
  EditorDecorBorderCenterH = 'editor-decor_border-center-h',
  EditorDecorBorderCenterV = 'editor-decor_border-center-v',
  EditorDecorBorderInner = 'editor-decor_border-inner',
  EditorDecorBorderLeft = 'editor-decor_border-left',
  EditorDecorBorderNone = 'editor-decor_border-none',
  EditorDecorBorderOuter = 'editor-decor_border-outer',
  EditorDecorBorderRight = 'editor-decor_border-right',
  EditorDecorBorderTopLeft = 'editor-decor_border-top-left',
  EditorDecorBorderTop = 'editor-decor_border-top',
  EditorDecorBracketsCurly = 'editor-decor_brackets-curly',
  EditorDecorBracketsSquare = 'editor-decor_brackets-square',
  EditorDecorBroom = 'editor-decor_broom',
  EditorDecorBrowser = 'editor-decor_browser',
  EditorDecorBrush = 'editor-decor_brush',
  EditorDecorCarouselFill = 'editor-decor_carousel-fill',
  EditorDecorCodeDownload = 'editor-decor_code-download',
  EditorDecorCodeSimple = 'editor-decor_code-simple',
  EditorDecorCode = 'editor-decor_code',
  EditorDecorCollageFill = 'editor-decor_collage-fill',
  EditorDecorColumnFill = 'editor-decor_column-fill',
  EditorDecorComponent = 'editor-decor_component',
  EditorDecorCopyColumn = 'editor-decor_copy-column',
  EditorDecorCopyRow = 'editor-decor_copy-row',
  EditorDecorCrop = 'editor-decor_crop',
  EditorDecorDashboardFill = 'editor-decor_dashboard-fill',
  EditorDecorDashboardVariantFill = 'editor-decor_dashboard-variant-fill',
  EditorDecorDayFill = 'editor-decor_day-fill',
  EditorDecorEraser = 'editor-decor_eraser',
  EditorDecorFill = 'editor-decor_fill',
  EditorDecorFunction = 'editor-decor_function',
  EditorDecorGridFill = 'editor-decor_grid-fill',
  EditorDecorGrid = 'editor-decor_grid',
  EditorDecorHashtag = 'editor-decor_hashtag',
  EditorDecorHeadlineFill = 'editor-decor_headline-fill',
  EditorDecorIndentArrowLeft = 'editor-decor_indent_arrow-left',
  EditorDecorIndentArrowRight = 'editor-decor_indent_arrow-right',
  EditorDecorItalic = 'editor-decor_italic',
  EditorDecorKeyboardClose = 'editor-decor_keyboard_close',
  EditorDecorKeyboard = 'editor-decor_keyboard',
  EditorDecorLayerGroupSlash = 'editor-decor_layer-group-slash',
  EditorDecorLayerGroup = 'editor-decor_layer-group',
  EditorDecorLineHeight = 'editor-decor_line-height',
  EditorDecorListFill = 'editor-decor_list-fill',
  EditorDecorListOl = 'editor-decor_list-ol',
  EditorDecorListUl = 'editor-decor_list-ul',
  EditorDecorMagicWand = 'editor-decor_magic_wand',
  EditorDecorModuleFill = 'editor-decor_module-fill',
  EditorDecorNpm = 'editor-decor_npm',
  EditorDecorObjectDownSubtract = 'editor-decor_object-down-subtract',
  EditorDecorObjectExclude = 'editor-decor_object-exclude',
  EditorDecorObjectIntersect = 'editor-decor_object-intersect',
  EditorDecorObjectSelection = 'editor-decor_object-selection',
  EditorDecorObjectUnion = 'editor-decor_object-union',
  EditorDecorObjectUpSubtract = 'editor-decor_object-up-subtract',
  EditorDecorObject = 'editor-decor_object',
  EditorDecorPalette = 'editor-decor_palette',
  EditorDecorPanelDown = 'editor-decor_panel-down',
  EditorDecorPanelLeft = 'editor-decor_panel-left',
  EditorDecorPanelRight = 'editor-decor_panel-right',
  EditorDecorPanelTop = 'editor-decor_panel-top',
  EditorDecorPantone = 'editor-decor_pantone',
  EditorDecorPercent = 'editor-decor_percent',
  EditorDecorPi = 'editor-decor_pi',
  EditorDecorPlusColumnRight = 'editor-decor_plus-column-right',
  EditorDecorPlusColumnTop = 'editor-decor_plus-column-top',
  EditorDecorPolyline = 'editor-decor_polyline',
  EditorDecorQuiltFill = 'editor-decor_quilt-fill',
  EditorDecorRuler = 'editor-decor_ruler',
  EditorDecorScissors = 'editor-decor_scissors',
  EditorDecorSendBackward = 'editor-decor_send-backward',
  EditorDecorSendForward = 'editor-decor_send-forward',
  EditorDecorSequentialFill = 'editor-decor_sequential-fill',
  EditorDecorShovel = 'editor-decor_shovel',
  EditorDecorSigma = 'editor-decor_sigma',
  EditorDecorSquareBracketCurlyRight_1 = 'editor-decor_square-bracket-curly-right-1',
  EditorDecorSquareBracketCurlyRight = 'editor-decor_square-bracket-curly-right',
  EditorDecorSquareBracketLeft = 'editor-decor_square-bracket-left',
  EditorDecorSquareBracketRight = 'editor-decor_square-bracket-right',
  EditorDecorSquareDivide = 'editor-decor_square-divide',
  EditorDecorSquareMinus = 'editor-decor_square-minus',
  EditorDecorSquareMultiply = 'editor-decor_square-multiply',
  EditorDecorSquarePercent = 'editor-decor_square-percent',
  EditorDecorSquarePlus = 'editor-decor_square-plus',
  EditorDecorStarLine = 'editor-decor_star-line',
  EditorDecorStrikethrough = 'editor-decor_strikethrough',
  EditorDecorSubskritDown = 'editor-decor_subskrit-down',
  EditorDecorSubskritUp = 'editor-decor_subskrit-up',
  EditorDecorTableDown = 'editor-decor_table-down',
  EditorDecorTableMagnifyingGlass = 'editor-decor_table-magnifying_glass',
  EditorDecorTableRight = 'editor-decor_table-right',
  EditorDecorTableTranspose = 'editor-decor_table-transpose',
  EditorDecorTable = 'editor-decor_table',
  EditorDecorTextColor = 'editor-decor_text-color',
  EditorDecorText = 'editor-decor_text',
  EditorDecorUnderlined = 'editor-decor_underlined',
  EditorDecorVectorCircleOnePoint = 'editor-decor_vector-circle-one-point',
  EditorDecorVectorCircleTwoPoint = 'editor-decor_vector-circle-two-point',
  EditorDecorVectorCircle = 'editor-decor_vector-circle',
  EditorDecorVectorLine = 'editor-decor_vector-line',
  EditorDecorVectorPoint = 'editor-decor_vector-point',
  EditorDecorVectorPolygon = 'editor-decor_vector-polygon',
  EditorDecorVectorRectangle = 'editor-decor_vector-rectangle',
  EditorDecorVectorSquare = 'editor-decor_vector-square',
  EditorDecorVectorTriangle = 'editor-decor_vector-triangle',
  EditorDecorVectorsRadius = 'editor-decor_vectors-radius',
  EditorDecorWindow = 'editor-decor_window',
  EditorDecorXmarkColumnRight = 'editor-decor_xmark-column-right',
  EditorDecorXmarkColumnTop = 'editor-decor_xmark-column-top',
  LogisticsTransportationAirplaneSideView = 'logistics-transportation_airplane-side-view',
  LogisticsTransportationAirplaneTopView = 'logistics-transportation_airplane-top-view',
  LogisticsTransportationAmbulanceSideView = 'logistics-transportation_ambulance-side-view',
  LogisticsTransportationCarJeepSideView = 'logistics-transportation_car-jeep-side-view',
  LogisticsTransportationCarLightSideView = 'logistics-transportation_car-light-side-view',
  LogisticsTransportationConcreteMixerSideView = 'logistics-transportation_concrete-mixer-side-view',
  LogisticsTransportationHelicopterSideView = 'logistics-transportation_helicopter-side-view',
  LogisticsTransportationMinibusSideView = 'logistics-transportation_minibus-side-view',
  LogisticsTransportationPaverSideView = 'logistics-transportation_paver-side-view',
  LogisticsTransportationPipeNodeSideView = 'logistics-transportation_pipe-node-side-view',
  LogisticsTransportationRailcarHopperSideView = 'logistics-transportation_railcar-hopper-side-view',
  LogisticsTransportationRailcarSideView = 'logistics-transportation_railcar-side-view',
  LogisticsTransportationShipFrontView = 'logistics-transportation_ship-front-view',
  LogisticsTransportationShipSideView = 'logistics-transportation_ship-side-view',
  LogisticsTransportationTankcarOilSideView = 'logistics-transportation_tankcar-oil-side-view',
  LogisticsTransportationTankcarSideView = 'logistics-transportation_tankcar-side-view',
  LogisticsTransportationTruckDumpSideView = 'logistics-transportation_truck-dump-side-view',
  LogisticsTransportationTruckEmptySideView = 'logistics-transportation_truck-empty-side-view',
  LogisticsTransportationTruckGarbageSideView = 'logistics-transportation_truck-garbage-side-view',
  LogisticsTransportationTruckGasolineSideView = 'logistics-transportation_truck-gasoline-side-view',
  LogisticsTransportationTruckSideView = 'logistics-transportation_truck-side-view',
  MapLocationCompass = 'map-location_compass',
  MapLocationCrosshairsDot = 'map-location_crosshairs-dot',
  MapLocationCrosshairsSimple = 'map-location_crosshairs-simple',
  MapLocationLocationArrow = 'map-location_location-arrow',
  MapLocationLocationDirectly = 'map-location_location-directly',
  MapLocationLocationDot = 'map-location_location-dot',
  MapLocationLocationMinus = 'map-location_location-minus',
  MapLocationLocationPlus = 'map-location_location-plus',
  MapLocationLocationSlash = 'map-location_location-slash',
  MapLocationLocationUser = 'map-location_location-user',
  MapLocationMapBase = 'map-location_map-base',
  MapLocationMapPin = 'map-location_map-pin',
  MapLocationMap = 'map-location_map',
  MapLocationThumbtackDirectly = 'map-location_thumbtack-directly',
  MapLocationThumbtack = 'map-location_thumbtack',
  MapLocationWorld_2 = 'map-location_world-2',
  MapLocationWorld = 'map-location_world',
  MultimediaDevicesAndroidPill = 'multimedia-devices_android-pill',
  MultimediaDevicesAndroid = 'multimedia-devices_android',
  MultimediaDevicesAudioSpeakers = 'multimedia-devices_audio-speakers',
  MultimediaDevicesBookmarkMusic = 'multimedia-devices_bookmark-music',
  MultimediaDevicesCameraFront = 'multimedia-devices_camera-front',
  MultimediaDevicesCameraMovieCross = 'multimedia-devices_camera-movie-cross',
  MultimediaDevicesCameraMovie = 'multimedia-devices_camera-movie',
  MultimediaDevicesCamera = 'multimedia-devices_camera',
  MultimediaDevicesCellphoneWireless = 'multimedia-devices_cellphone-wireless',
  MultimediaDevicesCellphone = 'multimedia-devices_cellphone',
  MultimediaDevicesCircleMusic = 'multimedia-devices_circle-music',
  MultimediaDevicesClapperboardCross = 'multimedia-devices_clapperboard-cross',
  MultimediaDevicesClapperboardOpen = 'multimedia-devices_clapperboard-open',
  MultimediaDevicesDesktopTower = 'multimedia-devices_desktop-tower',
  MultimediaDevicesFileMusic = 'multimedia-devices_file-music',
  MultimediaDevicesFilmCross = 'multimedia-devices_film-cross',
  MultimediaDevicesFilm = 'multimedia-devices_film',
  MultimediaDevicesForvardStep = 'multimedia-devices_forvard-step',
  MultimediaDevicesForward = 'multimedia-devices_forward',
  MultimediaDevicesHardDriveOutline = 'multimedia-devices_hard-drive-outline',
  MultimediaDevicesImage = 'multimedia-devices_image',
  MultimediaDevicesInfinity = 'multimedia-devices_infinity',
  MultimediaDevicesInputDevice = 'multimedia-devices_input-device',
  MultimediaDevicesLaptopPhoneSlash = 'multimedia-devices_laptop-phone-slash',
  MultimediaDevicesLaptopPhone = 'multimedia-devices_laptop-phone',
  MultimediaDevicesLaptopSlash = 'multimedia-devices_laptop-slash',
  MultimediaDevicesLaptop = 'multimedia-devices_laptop',
  MultimediaDevicesMicrophoneSlash = 'multimedia-devices_microphone-slash',
  MultimediaDevicesMicrophone = 'multimedia-devices_microphone',
  MultimediaDevicesMonitor = 'multimedia-devices_monitor',
  MultimediaDevicesMusicSlash = 'multimedia-devices_music-slash',
  MultimediaDevicesMusic = 'multimedia-devices_music',
  MultimediaDevicesPause = 'multimedia-devices_pause',
  MultimediaDevicesPlayBack = 'multimedia-devices_play-back',
  MultimediaDevicesPlay = 'multimedia-devices_play',
  MultimediaDevicesPrinter = 'multimedia-devices_printer',
  MultimediaDevicesPushButtonCellphone = 'multimedia-devices_push-button-cellphone',
  MultimediaDevicesReturnStep = 'multimedia-devices_return-step',
  MultimediaDevicesReturn = 'multimedia-devices_return',
  MultimediaDevicesSquareMusicDouble = 'multimedia-devices_square-music-double',
  MultimediaDevicesSquareMusic = 'multimedia-devices_square-music',
  MultimediaDevicesStop = 'multimedia-devices_stop',
  MultimediaDevicesTablet = 'multimedia-devices_tablet',
  MultimediaDevicesTouchpad = 'multimedia-devices_touchpad',
  MultimediaDevicesTransmitter = 'multimedia-devices_transmitter',
  MultimediaDevicesTv = 'multimedia-devices_tv',
  MultimediaDevicesVideoCross = 'multimedia-devices_video-cross',
  MultimediaDevicesVideoSlash = 'multimedia-devices_video-slash',
  MultimediaDevicesVideo = 'multimedia-devices_video',
  MultimediaDevicesVoicemail = 'multimedia-devices_voicemail',
  MultimediaDevicesVolumeCross = 'multimedia-devices_volume-cross',
  MultimediaDevicesVolumeLow = 'multimedia-devices_volume-low',
  MultimediaDevicesVolumeMinus = 'multimedia-devices_volume-minus',
  MultimediaDevicesVolumeOff = 'multimedia-devices_volume-off',
  MultimediaDevicesVolumePlus = 'multimedia-devices_volume-plus',
  MultimediaDevicesVolumeSlash = 'multimedia-devices_volume-slash',
  MultimediaDevicesVolume = 'multimedia-devices_volume',
  MultimediaDevicesWatch = 'multimedia-devices_watch',
  MultimediaDevicesWebcam = 'multimedia-devices_webcam',
  NotificationsAlertsBellFill = 'notifications-alerts_bell-fill',
  NotificationsAlertsBellPlus = 'notifications-alerts_bell-plus',
  NotificationsAlertsBellRingFill = 'notifications-alerts_bell-ring-fill',
  NotificationsAlertsBellRing = 'notifications-alerts_bell-ring',
  NotificationsAlertsBellSlash = 'notifications-alerts_bell-slash',
  NotificationsAlertsBell = 'notifications-alerts_bell',
  NotificationsAlertsCheckDouble = 'notifications-alerts_check-double',
  NotificationsAlertsChek = 'notifications-alerts_chek',
  NotificationsAlertsCircleChekEmpty = 'notifications-alerts_circle-chek-empty',
  NotificationsAlertsCircleChekFill = 'notifications-alerts_circle-chek-fill',
  NotificationsAlertsCircleExclamationEmpty = 'notifications-alerts_circle-exclamation-empty',
  NotificationsAlertsCircleExclamationFill = 'notifications-alerts_circle-exclamation-fill',
  NotificationsAlertsCircleInfoEmpty = 'notifications-alerts_circle-info-empty',
  NotificationsAlertsCircleInfoFill = 'notifications-alerts_circle-info-fill',
  NotificationsAlertsCircleQuestionEmpty = 'notifications-alerts_circle-question-empty',
  NotificationsAlertsCircleQuestionFill = 'notifications-alerts_circle-question-fill',
  NotificationsAlertsDecagramChekEmpty = 'notifications-alerts_decagram-chek-empty',
  NotificationsAlertsDecagramChekFill = 'notifications-alerts_decagram-chek-fill',
  NotificationsAlertsDecagramExclamationEmpty = 'notifications-alerts_decagram-exclamation-empty',
  NotificationsAlertsDecagramExclamationFill = 'notifications-alerts_decagram-exclamation-fill',
  NotificationsAlertsExclamation = 'notifications-alerts_exclamation',
  NotificationsAlertsFlagFillRed = 'notifications-alerts_flag-fill-red',
  NotificationsAlertsFlagFill = 'notifications-alerts_flag-fill',
  NotificationsAlertsFlag = 'notifications-alerts_flag',
  NotificationsAlertsHexagonExclamationEmpty = 'notifications-alerts_hexagon-exclamation-empty',
  NotificationsAlertsHexagonExclamationFill = 'notifications-alerts_hexagon-exclamation-fill',
  NotificationsAlertsInfo = 'notifications-alerts_info',
  NotificationsAlertsQuestion = 'notifications-alerts_question',
  NotificationsAlertsSquareExclamationEmpty = 'notifications-alerts_square-exclamation-empty',
  NotificationsAlertsSquareExclamationFill = 'notifications-alerts_square-exclamation-fill',
  NotificationsAlertsSquareInfoEmpty = 'notifications-alerts_square-info-empty',
  NotificationsAlertsSquareInfoFill = 'notifications-alerts_square-info-fill',
  NotificationsAlertsSquareQuestionEmpty = 'notifications-alerts_square-question-empty',
  NotificationsAlertsSquareQuestionFill = 'notifications-alerts_square-question-fill',
  NotificationsAlertsTriangleCrossEmpty = 'notifications-alerts_triangle-cross-empty',
  NotificationsAlertsTriangleExclamationEmpty = 'notifications-alerts_triangle-exclamation-empty',
  NotificationsAlertsTriangleExclamationFill = 'notifications-alerts_triangle-exclamation-fill',
  NotificationsAlertsTriangleInfoEmpty = 'notifications-alerts_triangle-info-empty',
  NotificationsAlertsTriangleInfoFill = 'notifications-alerts_triangle-info-fill',
  NotificationsAlertsTrianglePlusEmpty = 'notifications-alerts_triangle-plus-empty',
  OtherAward = 'other_award',
  OtherDefaultIco = 'other_default-ico',
  OtherFaceFrown = 'other_face-frown',
  OtherFaceSmile = 'other_face-smile',
  OtherGitLab = 'other_git-lab',
  OtherInstagram = 'other_instagram',
  OtherLogoGreyZ = 'other_logo-grey-z',
  OtherLogoSGrey = 'other_logo-s.grey',
  OtherMapMarkerDate_1 = 'other_map-marker-date-1',
  OtherMapMarkerDate_2 = 'other_map-marker-date-2',
  OtherOwl = 'other_owl',
  OtherPortfel = 'other_portfel',
  OtherTemperatureMinus = 'other_temperature-minus',
  OtherTemperaturePlus = 'other_temperature-plus',
  OtherTemperature = 'other_temperature',
  OtherTemplate = 'other_template',
  OtherUmbrella = 'other_umbrella',
  PowerEnergyBatteryBolt = 'power-energy_battery-bolt',
  PowerEnergyBatteryEmpty = 'power-energy_battery-empty',
  PowerEnergyBatteryExclametionMark = 'power-energy_battery-exclametion_mark',
  PowerEnergyBatteryFull = 'power-energy_battery-full',
  PowerEnergyBatteryHalf = 'power-energy_battery-half',
  PowerEnergyBatteryMinus = 'power-energy_battery-minus',
  PowerEnergyBatteryPlus = 'power-energy_battery-plus',
  PowerEnergyBatteryQuarter = 'power-energy_battery-quarter',
  PowerEnergyBatteryThreeQuarters = 'power-energy_battery-three-quarters',
  PowerEnergyEnergyCheck = 'power-energy_energy-check',
  PowerEnergyEnergySlash = 'power-energy_energy-slash',
  PowerEnergyEnergy = 'power-energy_energy',
  PowerEnergyPulse = 'power-energy_pulse',
  ProductionIndustryBalloon = 'production-industry_balloon',
  ProductionIndustryBoilerHotWaterGasAndOil = 'production-industry_boiler-hot-water-gas-and-oil',
  ProductionIndustryBoiler = 'production-industry_boiler',
  ProductionIndustryBurn = 'production-industry_burn',
  ProductionIndustryCarbon = 'production-industry_carbon',
  ProductionIndustryCartFlatbedContainer = 'production-industry_cart-flatbed-container',
  ProductionIndustryContainer_2 = 'editor-decor_table-magnifying_2',
  ProductionIndustryContainer = 'production-industry_container',
  ProductionIndustryContainers = 'production-industry_containers',
  ProductionIndustryCrane = 'production-industry_crane',
  ProductionIndustryCubeEmpty = 'production-industry_cube-empty',
  ProductionIndustryCubeFill = 'production-industry_cube-fill',
  ProductionIndustryCubes = 'production-industry_cubes',
  ProductionIndustryEarlyVersion = 'production-industry_early-version',
  ProductionIndustryElectrics = 'production-industry_electrics',
  ProductionIndustryExchanger = 'production-industry_exchanger',
  ProductionIndustryFactoryPipe = 'production-industry_factory-pipe',
  ProductionIndustryFactoryPipes = 'production-industry_factory-pipes',
  ProductionIndustryFactory = 'production-industry_factory',
  ProductionIndustryFan = 'production-industry_fan',
  ProductionIndustryFire = 'production-industry_fire',
  ProductionIndustryFlaskRoundPotion = 'production-industry_flask-round-potion',
  ProductionIndustryFlask = 'production-industry_flask',
  ProductionIndustryFuelOilTank = 'production-industry_fuel-oil-tank',
  ProductionIndustryGasMonitoring = 'production-industry_gas-monitoring',
  ProductionIndustryGasPump = 'production-industry_gas-pump',
  ProductionIndustryGas = 'production-industry_gas',
  ProductionIndustryGearCooling = 'production-industry_gear-cooling',
  ProductionIndustryGenerator = 'production-industry_generator',
  ProductionIndustryLngStorage = 'production-industry_lng-storage',
  ProductionIndustryMedical = 'production-industry_medical',
  ProductionIndustryNiFiLogo = 'production-industry_ni-fi-logo',
  ProductionIndustryOilBarrel = 'production-industry_oil-barrel',
  ProductionIndustryOilCanister = 'production-industry_oil-canister',
  ProductionIndustryOilDropletArrowsAll = 'production-industry_oil-droplet-arrows-all',
  ProductionIndustryOilDropletArrowsRepeatH = 'production-industry_oil-droplet-arrows-repeat-h',
  ProductionIndustryOilDropletChek = 'production-industry_oil-droplet-chek',
  ProductionIndustryOilDroplet = 'production-industry_oil-droplet',
  ProductionIndustryOilField = 'production-industry_oil-field',
  ProductionIndustryOilTank = 'production-industry_oil-tank',
  ProductionIndustryPipeSensor = 'production-industry_pipe-sensor',
  ProductionIndustryPipeValve = 'production-industry_pipe-valve',
  ProductionIndustryPipeline_2 = 'production-industry_pipeline_2',
  ProductionIndustryPipeline = 'production-industry_pipeline',
  ProductionIndustryPress = 'production-industry_press',
  ProductionIndustryPumpTriangleDown = 'production-industry_pump-triangle-down',
  ProductionIndustryPump = 'production-industry_pump',
  ProductionIndustryRadiation = 'production-industry_radiation',
  ProductionIndustryRespirator_1 = 'production-industry_respirator-1',
  ProductionIndustryRespirator_2 = 'production-industry_respirator-2',
  ProductionIndustryRespirator_3 = 'production-industry_respirator-3',
  ProductionIndustryRespirator_4 = 'production-industry_respirator-4',
  ProductionIndustryRespirator_5 = 'production-industry_respirator-5',
  ProductionIndustryRespirator_6 = 'production-industry_respirator-6',
  ProductionIndustrySeedlingCircle = 'production-industry_seedling-circle',
  ProductionIndustrySeedlingRectangle = 'production-industry_seedling-rectangle',
  ProductionIndustrySeedling = 'production-industry_seedling',
  ProductionIndustrySeparator = 'production-industry_separator',
  ProductionIndustrySnakeCup = 'production-industry_snake-cup',
  ProductionIndustrySnowflakeUpToBracket = 'production-industry_snowflake-up-to-bracket',
  ProductionIndustrySnowflake = 'production-industry_snowflake',
  ProductionIndustrySpeedReductionCooling = 'production-industry_speed-reduction-cooling',
  ProductionIndustrySteamBoiler = 'production-industry_steam-boiler',
  ProductionIndustrySteamTurbine = 'production-industry_steam-turbine',
  ProductionIndustrySteam = 'production-industry_steam',
  ProductionIndustryTank_1 = 'production-industry_tank-1',
  ProductionIndustryTank = 'production-industry_tank',
  ProductionIndustryVialArrowRotateLeft = 'production-industry_vial-arrow-rotate-left',
  ProductionIndustryVialFlask = 'production-industry_vial-flask',
  ProductionIndustryVialXmark = 'production-industry_vial-xmark',
  ProductionIndustryVial = 'production-industry_vial',
  ProductionIndustryWaterHeater = 'production-industry_water-heater',
  ProductionIndustryWaterPump = 'production-industry_water-pump',
  SettingsToolsBan = 'settings-tools_ban',
  SettingsToolsBars = 'settings-tools_bars',
  SettingsToolsCirclePlusFill = 'settings-tools_circle-plus-fill',
  SettingsToolsCirclePlus = 'settings-tools_circle-plus',
  SettingsToolsCircleXmarkFill = 'settings-tools_circle-xmark-fill',
  SettingsToolsCircleXmark = 'settings-tools_circle-xmark',
  SettingsToolsCopy = 'settings-tools_copy',
  SettingsToolsDeleteContent = 'settings-tools_delete-content',
  SettingsToolsDropletSlash = 'settings-tools_droplet-slash',
  SettingsToolsDroplet = 'settings-tools_droplet',
  SettingsToolsEllipsisGrid = 'settings-tools_ellipsis-grid',
  SettingsToolsEllipsisH = 'settings-tools_ellipsis-h',
  SettingsToolsEllipsisV = 'settings-tools_ellipsis-v',
  SettingsToolsEyeClosed = 'settings-tools_eye-closed',
  SettingsToolsEyeSlash = 'settings-tools_eye-slash',
  SettingsToolsEye = 'settings-tools_eye',
  SettingsToolsFilter = 'settings-tools_filter',
  SettingsToolsGear_5 = 'settings-tools_gear-5',
  SettingsToolsGear_8 = 'settings-tools_gear-8',
  SettingsToolsGripDotsVertical = 'settings-tools_grip-dots-vertical',
  SettingsToolsHouseMini = 'settings-tools_house-mini',
  SettingsToolsHouse = 'settings-tools_house',
  SettingsToolsKey = 'settings-tools_key',
  SettingsToolsLibraryPlus = 'settings-tools_library-plus',
  SettingsToolsLightbulb = 'settings-tools_lightbulb',
  SettingsToolsLinkBreak = 'settings-tools_link-break',
  SettingsToolsLinkMinus = 'settings-tools_link-minus',
  SettingsToolsLinkPlus = 'settings-tools_link-plus',
  SettingsToolsLinkSimpleH = 'settings-tools_link-simple-h',
  SettingsToolsLinkSimple = 'settings-tools_link-simple',
  SettingsToolsLoader = 'settings-tools_loader',
  SettingsToolsLock = 'settings-tools_lock',
  SettingsToolsMagnifyingGlassExclamation = 'settings-tools_magnifying_glass-exclamation',
  SettingsToolsMagnifyingGlassMinus = 'settings-tools_magnifying_glass-minus',
  SettingsToolsMagnifyingGlassPlus = 'settings-tools_magnifying_glass-plus',
  SettingsToolsMagnifyingGlassTopFromBracket = 'settings-tools_magnifying_glass-top-from_bracket',
  SettingsToolsMagnifyingGlassTriangleDown = 'settings-tools_magnifying_glass-triangle-down',
  SettingsToolsMagnifyingGlassXmark = 'settings-tools_magnifying_glass-xmark',
  SettingsToolsMagnifyingGlass = 'settings-tools_magnifying_glass',
  SettingsToolsMinusCircleFill = 'settings-tools_minus-circle-fill',
  SettingsToolsMinusCircle = 'settings-tools_minus-circle',
  SettingsToolsMinus = 'settings-tools_minus',
  SettingsToolsMoon = 'settings-tools_moon',
  SettingsToolsPaperclipVertical = 'settings-tools_paperclip-vertical',
  SettingsToolsPaperclip = 'settings-tools_paperclip',
  SettingsToolsPenHammer = 'settings-tools_pen-hammer',
  SettingsToolsPencilArrowRight = 'settings-tools_pencil_arrow-right',
  SettingsToolsPencilTriangleDown = 'settings-tools_pencil_triangle-down',
  SettingsToolsPencilTriangleLeft = 'settings-tools_pencil_triangle-left',
  SettingsToolsPencilLineBottom = 'settings-tools_pencil-line-bottom',
  SettingsToolsPencil = 'settings-tools_pencil',
  SettingsToolsPipette = 'settings-tools_pipette',
  SettingsToolsPlus = 'settings-tools_plus',
  SettingsToolsPower = 'settings-tools_power',
  SettingsToolsShieldExclamation = 'settings-tools_shield-exclamation',
  SettingsToolsShieldSlash = 'settings-tools_shield-slash',
  SettingsToolsShield = 'settings-tools_shield',
  SettingsToolsSlidersH = 'settings-tools_sliders-h',
  SettingsToolsSlidersV = 'settings-tools_sliders-v',
  SettingsToolsSun = 'settings-tools_sun',
  SettingsToolsTrashEmpty = 'settings-tools_trash-empty',
  SettingsToolsTrash = 'settings-tools_trash',
  SettingsToolsUnlock = 'settings-tools_unlock',
  SettingsToolsWrench = 'settings-tools_wrench',
  SettingsToolsXmarkMini = 'settings-tools_xmark-mini',
  SettingsToolsXmark = 'settings-tools_xmark',
  ShapeGeometryArrangeSendToBack = 'shape-geometry_arrange-send-to-back',
  ShapeGeometryCheckerboard = 'shape-geometry_checkerboard',
  ShapeGeometryCircleSquareInSquare = 'shape-geometry_circle_square-in-square',
  ShapeGeometryCircleSquareFill_1 = 'shape-geometry_circle_square-fill-1',
  ShapeGeometryCircleSquareFill = 'shape-geometry_circle_square-fill',
  ShapeGeometryCircleInHexagon = 'shape-geometry_circle-in-hexagon',
  ShapeGeometryCirclesLineLeftUpCircleRightDownFill = 'shape-geometry_circles-line-left-up_circle-right-down-fill',
  ShapeGeometryCirclesLineLeftUpCircleRightDown = 'shape-geometry_circles-line-left-up_circle-right-down',
  ShapeGeometryCollector = 'shape-geometry_collector',
  ShapeGeometryDiscreteSet = 'shape-geometry_discrete-set',
  ShapeGeometryHexagonFill = 'shape-geometry_hexagon-fill',
  ShapeGeometryHexagon = 'shape-geometry_hexagon',
  ShapeGeometryPentagonFill = 'shape-geometry_pentagon-fill',
  ShapeGeometryPentagon = 'shape-geometry_pentagon',
  ShapeGeometryRhombusFill = 'shape-geometry_rhombus-fill',
  ShapeGeometryRhombus = 'shape-geometry_rhombus',
  ShapeGeometryRingInSquare = 'shape-geometry_ring-in-square',
  ShapeGeometryShape_4F = 'shape-geometry_shape-4-f',
  ShapeGeometryShape_4 = 'shape-geometry_shape-4',
  ShapeGeometryShape_6 = 'shape-geometry_shape-6',
  ShapeGeometryShape_7 = 'shape-geometry_shape-7',
  ShapeGeometryShapePlus = 'shape-geometry_shape-plus',
  ShapeGeometrySquareCirclePlusTriangleFill = 'shape-geometry_square_circle_plus_triangle-fill',
  ShapeGeometrySquareCircleTriangleCrossFill = 'shape-geometry_square_circle_triangle_cross-fill',
  ShapeGeometrySquareCircleTriangleCross = 'shape-geometry_square_circle_triangle_cross',
  ShapeGeometrySquareHexagonCircleFill = 'shape-geometry_square_hexagon_circle-fill',
  ShapeGeometrySquareHexagonCircle = 'shape-geometry_square_hexagon_circle',
  ShapeGeometrySquareTriangleCircleTriangleFill_1 = 'shape-geometry_square_triangle_circle_triangle-fill-1',
  ShapeGeometrySquareTriangleCircleTriangleFill = 'shape-geometry_square_triangle_circle_triangle-fill',
  ShapeGeometrySquareInSquare = 'shape-geometry_square-in_square',
  ShapeGeometryTriangleCircleSquareFill_1 = 'shape-geometry_triangle_circle_square-fill-1',
  ShapeGeometryTriangleCircleSquareFill = 'shape-geometry_triangle_circle_square-fill',
  ShapeGeometryTriangleFill = 'shape-geometry_triangle-fill',
  ShapeGeometryTriangle = 'shape-geometry_triangle',
  UserAccountUserArrowsSwap = 'user-account_user-arrows_swap',
  UserAccountUserCard = 'user-account_user-card',
  UserAccountUserCheck = 'user-account_user-check',
  UserAccountUserCircle = 'user-account_user-circle',
  UserAccountUserCross = 'user-account_user-cross',
  UserAccountUserGear = 'user-account_user-gear',
  UserAccountUserLocation = 'user-account_user-location',
  UserAccountUserMinus = 'user-account_user-minus',
  UserAccountUserPen = 'user-account_user-pen',
  UserAccountUserPlus = 'user-account_user-plus',
  UserAccountUserShield = 'user-account_user-shield',
  UserAccountUserWorker = 'user-account_user-worker',
  UserAccountUser = 'user-account_user',
  UserAccountUsersArrowRight = 'user-account_users-arrow_right',
  UserAccountUsersGear = 'user-account_users-gear',
  UserAccountUsersKey = 'user-account_users-key',
  UserAccountUsersLocation = 'user-account_users-location',
  UserAccountUsersMinus = 'user-account_users-minus',
  UserAccountUsersPlus = 'user-account_users-plus',
  UserAccountUsers = 'user-account_users',
}

export const PRIZM_ICONS_CODEPOINTS: { [key in PrizmIconType]: string } = {
  [PrizmIconType.ChartsDiagramsBarAxis]: '61697',
  [PrizmIconType.ChartsDiagramsBarBasic]: '61698',
  [PrizmIconType.ChartsDiagramsBarColumnsAxisX]: '61699',
  [PrizmIconType.ChartsDiagramsBarColumns]: '61700',
  [PrizmIconType.ChartsDiagramsBarSquare]: '61701',
  [PrizmIconType.ChartsDiagramsBarStackedAxis]: '61702',
  [PrizmIconType.ChartsDiagramsBarStacked]: '61703',
  [PrizmIconType.ChartsDiagramsChartsHistogramChartDashed]: '61704',
  [PrizmIconType.ChartsDiagramsColumn]: '61705',
  [PrizmIconType.ChartsDiagramsDoughnut]: '61706',
  [PrizmIconType.ChartsDiagramsGantt]: '61707',
  [PrizmIconType.ChartsDiagramsGauge]: '61708',
  [PrizmIconType.ChartsDiagramsHexagonAxis]: '61709',
  [PrizmIconType.ChartsDiagramsHexagon]: '61710',
  [PrizmIconType.ChartsDiagramsHistogramAxis]: '61711',
  [PrizmIconType.ChartsDiagramsLineAxisX]: '61712',
  [PrizmIconType.ChartsDiagramsLineAxisArrowDown]: '61713',
  [PrizmIconType.ChartsDiagramsLineAxis]: '61714',
  [PrizmIconType.ChartsDiagramsLineDown]: '61715',
  [PrizmIconType.ChartsDiagramsLineMultipleYAxisX]: '61716',
  [PrizmIconType.ChartsDiagramsLineMultipleYAxis]: '61717',
  [PrizmIconType.ChartsDiagramsLineUp]: '61718',
  [PrizmIconType.ChartsDiagramsLine]: '61719',
  [PrizmIconType.ChartsDiagramsPieLineNested]: '61720',
  [PrizmIconType.ChartsDiagramsPieLine]: '61721',
  [PrizmIconType.ChartsDiagramsPiePentagon]: '61722',
  [PrizmIconType.ChartsDiagramsPieSeveralParts]: '61723',
  [PrizmIconType.ChartsDiagramsPieSimple]: '61724',
  [PrizmIconType.ChartsDiagramsPie]: '61725',
  [PrizmIconType.ChartsDiagramsRange]: '61726',
  [PrizmIconType.ChartsDiagramsScatterAxis]: '61727',
  [PrizmIconType.ChartsDiagramsScatterBasic]: '61728',
  [PrizmIconType.ChartsDiagramsScatter]: '61729',
  [PrizmIconType.CommunicationConnectionAtSign]: '61730',
  [PrizmIconType.CommunicationConnectionBluetooth]: '61731',
  [PrizmIconType.CommunicationConnectionBubbleMessageAdd]: '61732',
  [PrizmIconType.CommunicationConnectionBubbleMessageAttention]: '61733',
  [PrizmIconType.CommunicationConnectionBubbleMessageCircle]: '61734',
  [PrizmIconType.CommunicationConnectionBubbleMessageEmpty]: '61735',
  [PrizmIconType.CommunicationConnectionBubbleMessageOff]: '61736',
  [PrizmIconType.CommunicationConnectionBubbleMessageQuestion]: '61737',
  [PrizmIconType.CommunicationConnectionBubbleMessageText]: '61738',
  [PrizmIconType.CommunicationConnectionBubbleMessage]: '61739',
  [PrizmIconType.CommunicationConnectionHeadphones]: '61740',
  [PrizmIconType.CommunicationConnectionHeartEmpty]: '61741',
  [PrizmIconType.CommunicationConnectionHeartFill]: '61742',
  [PrizmIconType.CommunicationConnectionMailOpen]: '61743',
  [PrizmIconType.CommunicationConnectionMail]: '61744',
  [PrizmIconType.CommunicationConnectionMailbox]: '61745',
  [PrizmIconType.CommunicationConnectionMessagingTelegramSend]: '61746',
  [PrizmIconType.CommunicationConnectionMessagingTelegram]: '61747',
  [PrizmIconType.CommunicationConnectionPhoneActiveCall]: '61748',
  [PrizmIconType.CommunicationConnectionPhoneCancelled]: '61749',
  [PrizmIconType.CommunicationConnectionPhoneMinus]: '61750',
  [PrizmIconType.CommunicationConnectionPhoneOff]: '61751',
  [PrizmIconType.CommunicationConnectionPhonePaused]: '61752',
  [PrizmIconType.CommunicationConnectionPhonePlus]: '61753',
  [PrizmIconType.CommunicationConnectionPhone]: '61754',
  [PrizmIconType.CommunicationConnectionShareLeft]: '61755',
  [PrizmIconType.CommunicationConnectionShareRight]: '61756',
  [PrizmIconType.CommunicationConnectionShareing]: '61757',
  [PrizmIconType.CommunicationConnectionSignalAccessPoint]: '61758',
  [PrizmIconType.CommunicationConnectionSignalOff]: '61759',
  [PrizmIconType.CommunicationConnectionSignalRadioTower]: '61760',
  [PrizmIconType.CommunicationConnectionSignal]: '61761',
  [PrizmIconType.CommunicationConnectionStarEmpty]: '61762',
  [PrizmIconType.CommunicationConnectionStarFill]: '61763',
  [PrizmIconType.CommunicationConnectionStarHalfFill]: '61764',
  [PrizmIconType.CommunicationConnectionSupportMan]: '61765',
  [PrizmIconType.CommunicationConnectionThumbDown]: '61766',
  [PrizmIconType.CommunicationConnectionThumbUp]: '61767',
  [PrizmIconType.CommunicationConnectionWifiOff]: '61768',
  [PrizmIconType.CommunicationConnectionWifi]: '61769',
  [PrizmIconType.DataNetworkDatabaseChek]: '61770',
  [PrizmIconType.DataNetworkDatabaseJson]: '61771',
  [PrizmIconType.DataNetworkDatabaseMagnifyingGlass]: '61772',
  [PrizmIconType.DataNetworkDatabaseMinus]: '61773',
  [PrizmIconType.DataNetworkDatabasePlus]: '61774',
  [PrizmIconType.DataNetworkDatabaseSql]: '61775',
  [PrizmIconType.DataNetworkDatabaseXmark]: '61776',
  [PrizmIconType.DataNetworkDatabase]: '61777',
  [PrizmIconType.DataNetworkEthernet]: '61778',
  [PrizmIconType.DataNetworkLanConnect]: '61779',
  [PrizmIconType.DataNetworkLanDisconnect]: '61780',
  [PrizmIconType.DataNetworkLanPending]: '61781',
  [PrizmIconType.DataNetworkNetwork_1]: '61782',
  [PrizmIconType.DataNetworkNetwork_2]: '61783',
  [PrizmIconType.DataNetworkNetwork_3]: '61784',
  [PrizmIconType.DataNetworkNetworkWired]: '61785',
  [PrizmIconType.DataNetworkServerClose]: '61786',
  [PrizmIconType.DataNetworkServerDownload]: '61787',
  [PrizmIconType.DataNetworkServerMinus]: '61788',
  [PrizmIconType.DataNetworkServerOne]: '61789',
  [PrizmIconType.DataNetworkServerPlus]: '61790',
  [PrizmIconType.DataNetworkServerSecurity]: '61791',
  [PrizmIconType.DataNetworkServerShield]: '61792',
  [PrizmIconType.DataNetworkServerSlashUpLine]: '61793',
  [PrizmIconType.DataNetworkServerSlash]: '61794',
  [PrizmIconType.DataNetworkServerUpLine]: '61795',
  [PrizmIconType.DataNetworkServerUpload]: '61796',
  [PrizmIconType.DataNetworkServer]: '61797',
  [PrizmIconType.DateTimeAlarmClock]: '61798',
  [PrizmIconType.DateTimeAlarmPlus]: '61799',
  [PrizmIconType.DateTimeCalendarBlank]: '61800',
  [PrizmIconType.DateTimeCalendarCheck]: '61801',
  [PrizmIconType.DateTimeCalendarClock]: '61802',
  [PrizmIconType.DateTimeCalendarDeleted]: '61803',
  [PrizmIconType.DateTimeCalendarEvent]: '61804',
  [PrizmIconType.DateTimeCalendarPlus]: '61805',
  [PrizmIconType.DateTimeCalendarQuestion]: '61806',
  [PrizmIconType.DateTimeCalendarRange]: '61807',
  [PrizmIconType.DateTimeCalendarToday]: '61808',
  [PrizmIconType.DateTimeCalendar]: '61809',
  [PrizmIconType.DateTimeClockAdd]: '61810',
  [PrizmIconType.DateTimeClockArrowDown]: '61811',
  [PrizmIconType.DateTimeClockArrowRight]: '61812',
  [PrizmIconType.DateTimeClockArrowUp]: '61813',
  [PrizmIconType.DateTimeClockDeleted]: '61814',
  [PrizmIconType.DateTimeClockExclamation]: '61815',
  [PrizmIconType.DateTimeClockLineEnd]: '61816',
  [PrizmIconType.DateTimeClockRotateLeft]: '61817',
  [PrizmIconType.DateTimeClockRotateRight]: '61818',
  [PrizmIconType.DateTimeClock]: '61819',
  [PrizmIconType.DateTimeLetterDay]: '61820',
  [PrizmIconType.DateTimeLetterHour]: '61821',
  [PrizmIconType.DateTimeLetterMinute]: '61822',
  [PrizmIconType.DateTimeLetterMonth]: '61823',
  [PrizmIconType.DateTimeLetterSecond]: '61824',
  [PrizmIconType.DateTimeLetterTime]: '61825',
  [PrizmIconType.DateTimeLetterYear]: '61826',
  [PrizmIconType.DateTimeSandglass]: '61827',
  [PrizmIconType.DateTimeStopwatch]: '61828',
  [PrizmIconType.DateTimeSumbolAsterisk]: '61829',
  [PrizmIconType.DocumentsFoldersBookStack]: '61830',
  [PrizmIconType.DocumentsFoldersBoxOpenArrowDown]: '61831',
  [PrizmIconType.DocumentsFoldersBox]: '61832',
  [PrizmIconType.DocumentsFoldersCloudArrowDown]: '61833',
  [PrizmIconType.DocumentsFoldersCloudArrowUpInside]: '61834',
  [PrizmIconType.DocumentsFoldersCloudArrowUp]: '61835',
  [PrizmIconType.DocumentsFoldersCloudCheck]: '61836',
  [PrizmIconType.DocumentsFoldersCloud]: '61837',
  [PrizmIconType.DocumentsFoldersCollection_2]: '61838',
  [PrizmIconType.DocumentsFoldersFileArrowDownLeft]: '61839',
  [PrizmIconType.DocumentsFoldersFileArrowDown]: '61840',
  [PrizmIconType.DocumentsFoldersFileArrowUp]: '61841',
  [PrizmIconType.DocumentsFoldersFileArrow]: '61842',
  [PrizmIconType.DocumentsFoldersFileArrowsUpRight]: '61843',
  [PrizmIconType.DocumentsFoldersFileCamera]: '61844',
  [PrizmIconType.DocumentsFoldersFileCrossOut]: '61845',
  [PrizmIconType.DocumentsFoldersFileCross]: '61846',
  [PrizmIconType.DocumentsFoldersFileDoc]: '61847',
  [PrizmIconType.DocumentsFoldersFileDocx]: '61848',
  [PrizmIconType.DocumentsFoldersFileDot]: '61849',
  [PrizmIconType.DocumentsFoldersFileEmpty]: '61850',
  [PrizmIconType.DocumentsFoldersFileExclamatio]: '61851',
  [PrizmIconType.DocumentsFoldersFileEye]: '61852',
  [PrizmIconType.DocumentsFoldersFileFilled]: '61853',
  [PrizmIconType.DocumentsFoldersFileImage]: '61854',
  [PrizmIconType.DocumentsFoldersFileMagnifyingGlass]: '61855',
  [PrizmIconType.DocumentsFoldersFileMinus]: '61856',
  [PrizmIconType.DocumentsFoldersFilePdf]: '61857',
  [PrizmIconType.DocumentsFoldersFilePen]: '61858',
  [PrizmIconType.DocumentsFoldersFilePlay]: '61859',
  [PrizmIconType.DocumentsFoldersFilePlus]: '61860',
  [PrizmIconType.DocumentsFoldersFilePpt]: '61861',
  [PrizmIconType.DocumentsFoldersFilePptx]: '61862',
  [PrizmIconType.DocumentsFoldersFileTxt]: '61863',
  [PrizmIconType.DocumentsFoldersFileUpRight]: '61864',
  [PrizmIconType.DocumentsFoldersFileXls]: '61865',
  [PrizmIconType.DocumentsFoldersFileXlsx]: '61866',
  [PrizmIconType.DocumentsFoldersFloppyCrossOut]: '61867',
  [PrizmIconType.DocumentsFoldersFloppyCross]: '61868',
  [PrizmIconType.DocumentsFoldersFloppyPen]: '61869',
  [PrizmIconType.DocumentsFoldersFloppyStar]: '61870',
  [PrizmIconType.DocumentsFoldersFloppy]: '61871',
  [PrizmIconType.DocumentsFoldersFolderArrowDownLeft]: '61872',
  [PrizmIconType.DocumentsFoldersFolderArrowDown]: '61873',
  [PrizmIconType.DocumentsFoldersFolderArrowUpRight]: '61874',
  [PrizmIconType.DocumentsFoldersFolderCross]: '61875',
  [PrizmIconType.DocumentsFoldersFolderDot]: '61876',
  [PrizmIconType.DocumentsFoldersFolderMinus]: '61877',
  [PrizmIconType.DocumentsFoldersFolderPlus]: '61878',
  [PrizmIconType.DocumentsFoldersFolderOpen]: '61879',
  [PrizmIconType.DocumentsFoldersFolderUnderlineMinus]: '61880',
  [PrizmIconType.DocumentsFoldersFolderUnderlinePlus]: '61881',
  [PrizmIconType.DocumentsFoldersFolderUnderline]: '61882',
  [PrizmIconType.DocumentsFoldersFolder]: '61883',
  [PrizmIconType.DocumentsFoldersListSquare]: '61884',
  [PrizmIconType.DocumentsFoldersListTreeArchive]: '61885',
  [PrizmIconType.DocumentsFoldersListTree]: '61886',
  [PrizmIconType.DocumentsFoldersList]: '61887',
  [PrizmIconType.DocumentsFoldersOntology]: '61888',
  [PrizmIconType.DocumentsFoldersSpecification]: '61889',
  [PrizmIconType.DocumentsFoldersSquareArrowsCurveRightDown]: '61890',
  [PrizmIconType.DocumentsFoldersSquareArrowsCurveUpRight]: '61891',
  [PrizmIconType.DocumentsFoldersSquareExcel]: '61892',
  [PrizmIconType.DocumentsFoldersSquarePowerpoint]: '61893',
  [PrizmIconType.DocumentsFoldersSquareWord]: '61894',
  [PrizmIconType.DocumentsFoldersTablet]: '61895',
  [PrizmIconType.EditorDecorAgendaFill]: '61896',
  [PrizmIconType.EditorDecorAlignBottom]: '61897',
  [PrizmIconType.EditorDecorAlignCenterH]: '61898',
  [PrizmIconType.EditorDecorAlignCenterV]: '61899',
  [PrizmIconType.EditorDecorAlignCenter]: '61900',
  [PrizmIconType.EditorDecorAlignJustify]: '61901',
  [PrizmIconType.EditorDecorAlignLeft]: '61902',
  [PrizmIconType.EditorDecorAlignRight]: '61903',
  [PrizmIconType.EditorDecorAlignTop]: '61904',
  [PrizmIconType.EditorDecorArrayFill]: '61905',
  [PrizmIconType.EditorDecorBarsSort]: '61906',
  [PrizmIconType.EditorDecorBdrvAdministration]: '61907',
  [PrizmIconType.EditorDecorBezierCurve]: '61908',
  [PrizmIconType.EditorDecorBold]: '61909',
  [PrizmIconType.EditorDecorBorderAll]: '61910',
  [PrizmIconType.EditorDecorBorderBottom]: '61911',
  [PrizmIconType.EditorDecorBorderCenterH]: '61912',
  [PrizmIconType.EditorDecorBorderCenterV]: '61913',
  [PrizmIconType.EditorDecorBorderInner]: '61914',
  [PrizmIconType.EditorDecorBorderLeft]: '61915',
  [PrizmIconType.EditorDecorBorderNone]: '61916',
  [PrizmIconType.EditorDecorBorderOuter]: '61917',
  [PrizmIconType.EditorDecorBorderRight]: '61918',
  [PrizmIconType.EditorDecorBorderTopLeft]: '61919',
  [PrizmIconType.EditorDecorBorderTop]: '61920',
  [PrizmIconType.EditorDecorBracketsCurly]: '61921',
  [PrizmIconType.EditorDecorBracketsSquare]: '61922',
  [PrizmIconType.EditorDecorBroom]: '61923',
  [PrizmIconType.EditorDecorBrowser]: '61924',
  [PrizmIconType.EditorDecorBrush]: '61925',
  [PrizmIconType.EditorDecorCarouselFill]: '61926',
  [PrizmIconType.EditorDecorCodeDownload]: '61927',
  [PrizmIconType.EditorDecorCodeSimple]: '61928',
  [PrizmIconType.EditorDecorCode]: '61929',
  [PrizmIconType.EditorDecorCollageFill]: '61930',
  [PrizmIconType.EditorDecorColumnFill]: '61931',
  [PrizmIconType.EditorDecorComponent]: '61932',
  [PrizmIconType.EditorDecorCopyColumn]: '61933',
  [PrizmIconType.EditorDecorCopyRow]: '61934',
  [PrizmIconType.EditorDecorCrop]: '61935',
  [PrizmIconType.EditorDecorDashboardFill]: '61936',
  [PrizmIconType.EditorDecorDashboardVariantFill]: '61937',
  [PrizmIconType.EditorDecorDayFill]: '61938',
  [PrizmIconType.EditorDecorEraser]: '61939',
  [PrizmIconType.EditorDecorFill]: '61940',
  [PrizmIconType.EditorDecorFunction]: '61941',
  [PrizmIconType.EditorDecorGridFill]: '61942',
  [PrizmIconType.EditorDecorGrid]: '61943',
  [PrizmIconType.EditorDecorHashtag]: '61944',
  [PrizmIconType.EditorDecorHeadlineFill]: '61945',
  [PrizmIconType.EditorDecorIndentArrowLeft]: '61946',
  [PrizmIconType.EditorDecorIndentArrowRight]: '61947',
  [PrizmIconType.EditorDecorItalic]: '61948',
  [PrizmIconType.EditorDecorKeyboardClose]: '61949',
  [PrizmIconType.EditorDecorKeyboard]: '61950',
  [PrizmIconType.EditorDecorLayerGroupSlash]: '61951',
  [PrizmIconType.EditorDecorLayerGroup]: '61952',
  [PrizmIconType.EditorDecorLineHeight]: '61953',
  [PrizmIconType.EditorDecorListFill]: '61954',
  [PrizmIconType.EditorDecorListOl]: '61955',
  [PrizmIconType.EditorDecorListUl]: '61956',
  [PrizmIconType.EditorDecorMagicWand]: '61957',
  [PrizmIconType.EditorDecorModuleFill]: '61958',
  [PrizmIconType.EditorDecorNpm]: '61959',
  [PrizmIconType.EditorDecorObjectDownSubtract]: '61960',
  [PrizmIconType.EditorDecorObjectExclude]: '61961',
  [PrizmIconType.EditorDecorObjectIntersect]: '61962',
  [PrizmIconType.EditorDecorObjectSelection]: '61963',
  [PrizmIconType.EditorDecorObjectUnion]: '61964',
  [PrizmIconType.EditorDecorObjectUpSubtract]: '61965',
  [PrizmIconType.EditorDecorObject]: '61966',
  [PrizmIconType.EditorDecorPalette]: '61967',
  [PrizmIconType.EditorDecorPanelDown]: '61968',
  [PrizmIconType.EditorDecorPanelLeft]: '61969',
  [PrizmIconType.EditorDecorPanelRight]: '61970',
  [PrizmIconType.EditorDecorPanelTop]: '61971',
  [PrizmIconType.EditorDecorPantone]: '61972',
  [PrizmIconType.EditorDecorPercent]: '61973',
  [PrizmIconType.EditorDecorPi]: '61974',
  [PrizmIconType.EditorDecorPlusColumnRight]: '61975',
  [PrizmIconType.EditorDecorPlusColumnTop]: '61976',
  [PrizmIconType.EditorDecorPolyline]: '61977',
  [PrizmIconType.EditorDecorQuiltFill]: '61978',
  [PrizmIconType.EditorDecorRuler]: '61979',
  [PrizmIconType.EditorDecorScissors]: '61980',
  [PrizmIconType.EditorDecorSendBackward]: '61981',
  [PrizmIconType.EditorDecorSendForward]: '61982',
  [PrizmIconType.EditorDecorSequentialFill]: '61983',
  [PrizmIconType.EditorDecorShovel]: '61984',
  [PrizmIconType.EditorDecorSigma]: '61985',
  [PrizmIconType.EditorDecorSquareBracketCurlyRight_1]: '61986',
  [PrizmIconType.EditorDecorSquareBracketCurlyRight]: '61987',
  [PrizmIconType.EditorDecorSquareBracketLeft]: '61988',
  [PrizmIconType.EditorDecorSquareBracketRight]: '61989',
  [PrizmIconType.EditorDecorSquareDivide]: '61990',
  [PrizmIconType.EditorDecorSquareMinus]: '61991',
  [PrizmIconType.EditorDecorSquareMultiply]: '61992',
  [PrizmIconType.EditorDecorSquarePercent]: '61993',
  [PrizmIconType.EditorDecorSquarePlus]: '61994',
  [PrizmIconType.EditorDecorStarLine]: '61995',
  [PrizmIconType.EditorDecorStrikethrough]: '61996',
  [PrizmIconType.EditorDecorSubskritDown]: '61997',
  [PrizmIconType.EditorDecorSubskritUp]: '61998',
  [PrizmIconType.EditorDecorTableDown]: '61999',
  [PrizmIconType.EditorDecorTableMagnifyingGlass]: '62000',
  [PrizmIconType.EditorDecorTableRight]: '62001',
  [PrizmIconType.EditorDecorTableTranspose]: '62002',
  [PrizmIconType.EditorDecorTable]: '62003',
  [PrizmIconType.EditorDecorTextColor]: '62004',
  [PrizmIconType.EditorDecorText]: '62005',
  [PrizmIconType.EditorDecorUnderlined]: '62006',
  [PrizmIconType.EditorDecorVectorCircleOnePoint]: '62007',
  [PrizmIconType.EditorDecorVectorCircleTwoPoint]: '62008',
  [PrizmIconType.EditorDecorVectorCircle]: '62009',
  [PrizmIconType.EditorDecorVectorLine]: '62010',
  [PrizmIconType.EditorDecorVectorPoint]: '62011',
  [PrizmIconType.EditorDecorVectorPolygon]: '62012',
  [PrizmIconType.EditorDecorVectorRectangle]: '62013',
  [PrizmIconType.EditorDecorVectorSquare]: '62014',
  [PrizmIconType.EditorDecorVectorTriangle]: '62015',
  [PrizmIconType.EditorDecorVectorsRadius]: '62016',
  [PrizmIconType.EditorDecorWindow]: '62017',
  [PrizmIconType.EditorDecorXmarkColumnRight]: '62018',
  [PrizmIconType.EditorDecorXmarkColumnTop]: '62019',
  [PrizmIconType.LogisticsTransportationAirplaneSideView]: '62020',
  [PrizmIconType.LogisticsTransportationAirplaneTopView]: '62021',
  [PrizmIconType.LogisticsTransportationAmbulanceSideView]: '62022',
  [PrizmIconType.LogisticsTransportationCarJeepSideView]: '62023',
  [PrizmIconType.LogisticsTransportationCarLightSideView]: '62024',
  [PrizmIconType.LogisticsTransportationConcreteMixerSideView]: '62025',
  [PrizmIconType.LogisticsTransportationHelicopterSideView]: '62026',
  [PrizmIconType.LogisticsTransportationMinibusSideView]: '62027',
  [PrizmIconType.LogisticsTransportationPaverSideView]: '62028',
  [PrizmIconType.LogisticsTransportationPipeNodeSideView]: '62029',
  [PrizmIconType.LogisticsTransportationRailcarHopperSideView]: '62030',
  [PrizmIconType.LogisticsTransportationRailcarSideView]: '62031',
  [PrizmIconType.LogisticsTransportationShipFrontView]: '62032',
  [PrizmIconType.LogisticsTransportationShipSideView]: '62033',
  [PrizmIconType.LogisticsTransportationTankcarOilSideView]: '62034',
  [PrizmIconType.LogisticsTransportationTankcarSideView]: '62035',
  [PrizmIconType.LogisticsTransportationTruckDumpSideView]: '62036',
  [PrizmIconType.LogisticsTransportationTruckEmptySideView]: '62037',
  [PrizmIconType.LogisticsTransportationTruckGarbageSideView]: '62038',
  [PrizmIconType.LogisticsTransportationTruckGasolineSideView]: '62039',
  [PrizmIconType.LogisticsTransportationTruckSideView]: '62040',
  [PrizmIconType.MapLocationCompass]: '62041',
  [PrizmIconType.MapLocationCrosshairsDot]: '62042',
  [PrizmIconType.MapLocationCrosshairsSimple]: '62043',
  [PrizmIconType.MapLocationLocationArrow]: '62044',
  [PrizmIconType.MapLocationLocationDirectly]: '62045',
  [PrizmIconType.MapLocationLocationDot]: '62046',
  [PrizmIconType.MapLocationLocationMinus]: '62047',
  [PrizmIconType.MapLocationLocationPlus]: '62048',
  [PrizmIconType.MapLocationLocationSlash]: '62049',
  [PrizmIconType.MapLocationLocationUser]: '62050',
  [PrizmIconType.MapLocationMapBase]: '62051',
  [PrizmIconType.MapLocationMapPin]: '62052',
  [PrizmIconType.MapLocationMap]: '62053',
  [PrizmIconType.MapLocationThumbtackDirectly]: '62054',
  [PrizmIconType.MapLocationThumbtack]: '62055',
  [PrizmIconType.MapLocationWorld_2]: '62056',
  [PrizmIconType.MapLocationWorld]: '62057',
  [PrizmIconType.MultimediaDevicesAndroidPill]: '62058',
  [PrizmIconType.MultimediaDevicesAndroid]: '62059',
  [PrizmIconType.MultimediaDevicesAudioSpeakers]: '62060',
  [PrizmIconType.MultimediaDevicesBookmarkMusic]: '62061',
  [PrizmIconType.MultimediaDevicesCameraFront]: '62062',
  [PrizmIconType.MultimediaDevicesCameraMovieCross]: '62063',
  [PrizmIconType.MultimediaDevicesCameraMovie]: '62064',
  [PrizmIconType.MultimediaDevicesCamera]: '62065',
  [PrizmIconType.MultimediaDevicesCellphoneWireless]: '62066',
  [PrizmIconType.MultimediaDevicesCellphone]: '62067',
  [PrizmIconType.MultimediaDevicesCircleMusic]: '62068',
  [PrizmIconType.MultimediaDevicesClapperboardCross]: '62069',
  [PrizmIconType.MultimediaDevicesClapperboardOpen]: '62070',
  [PrizmIconType.MultimediaDevicesDesktopTower]: '62071',
  [PrizmIconType.MultimediaDevicesFileMusic]: '62072',
  [PrizmIconType.MultimediaDevicesFilmCross]: '62073',
  [PrizmIconType.MultimediaDevicesFilm]: '62074',
  [PrizmIconType.MultimediaDevicesForvardStep]: '62075',
  [PrizmIconType.MultimediaDevicesForward]: '62076',
  [PrizmIconType.MultimediaDevicesHardDriveOutline]: '62077',
  [PrizmIconType.MultimediaDevicesImage]: '62078',
  [PrizmIconType.MultimediaDevicesInfinity]: '62079',
  [PrizmIconType.MultimediaDevicesInputDevice]: '62080',
  [PrizmIconType.MultimediaDevicesLaptopPhoneSlash]: '62081',
  [PrizmIconType.MultimediaDevicesLaptopPhone]: '62082',
  [PrizmIconType.MultimediaDevicesLaptopSlash]: '62083',
  [PrizmIconType.MultimediaDevicesLaptop]: '62084',
  [PrizmIconType.MultimediaDevicesMicrophoneSlash]: '62085',
  [PrizmIconType.MultimediaDevicesMicrophone]: '62086',
  [PrizmIconType.MultimediaDevicesMonitor]: '62087',
  [PrizmIconType.MultimediaDevicesMusicSlash]: '62088',
  [PrizmIconType.MultimediaDevicesMusic]: '62089',
  [PrizmIconType.MultimediaDevicesPause]: '62090',
  [PrizmIconType.MultimediaDevicesPlayBack]: '62091',
  [PrizmIconType.MultimediaDevicesPlay]: '62092',
  [PrizmIconType.MultimediaDevicesPrinter]: '62093',
  [PrizmIconType.MultimediaDevicesPushButtonCellphone]: '62094',
  [PrizmIconType.MultimediaDevicesReturnStep]: '62095',
  [PrizmIconType.MultimediaDevicesReturn]: '62096',
  [PrizmIconType.MultimediaDevicesSquareMusicDouble]: '62097',
  [PrizmIconType.MultimediaDevicesSquareMusic]: '62098',
  [PrizmIconType.MultimediaDevicesStop]: '62099',
  [PrizmIconType.MultimediaDevicesTablet]: '62100',
  [PrizmIconType.MultimediaDevicesTouchpad]: '62101',
  [PrizmIconType.MultimediaDevicesTransmitter]: '62102',
  [PrizmIconType.MultimediaDevicesTv]: '62103',
  [PrizmIconType.MultimediaDevicesVideoCross]: '62104',
  [PrizmIconType.MultimediaDevicesVideoSlash]: '62105',
  [PrizmIconType.MultimediaDevicesVideo]: '62106',
  [PrizmIconType.MultimediaDevicesVoicemail]: '62107',
  [PrizmIconType.MultimediaDevicesVolumeCross]: '62108',
  [PrizmIconType.MultimediaDevicesVolumeLow]: '62109',
  [PrizmIconType.MultimediaDevicesVolumeMinus]: '62110',
  [PrizmIconType.MultimediaDevicesVolumeOff]: '62111',
  [PrizmIconType.MultimediaDevicesVolumePlus]: '62112',
  [PrizmIconType.MultimediaDevicesVolumeSlash]: '62113',
  [PrizmIconType.MultimediaDevicesVolume]: '62114',
  [PrizmIconType.MultimediaDevicesWatch]: '62115',
  [PrizmIconType.MultimediaDevicesWebcam]: '62116',
  [PrizmIconType.NotificationsAlertsBellFill]: '62117',
  [PrizmIconType.NotificationsAlertsBellPlus]: '62118',
  [PrizmIconType.NotificationsAlertsBellRingFill]: '62119',
  [PrizmIconType.NotificationsAlertsBellRing]: '62120',
  [PrizmIconType.NotificationsAlertsBellSlash]: '62121',
  [PrizmIconType.NotificationsAlertsBell]: '62122',
  [PrizmIconType.NotificationsAlertsCheckDouble]: '62123',
  [PrizmIconType.NotificationsAlertsChek]: '62124',
  [PrizmIconType.NotificationsAlertsCircleChekEmpty]: '62125',
  [PrizmIconType.NotificationsAlertsCircleChekFill]: '62126',
  [PrizmIconType.NotificationsAlertsCircleExclamationEmpty]: '62127',
  [PrizmIconType.NotificationsAlertsCircleExclamationFill]: '62128',
  [PrizmIconType.NotificationsAlertsCircleInfoEmpty]: '62129',
  [PrizmIconType.NotificationsAlertsCircleInfoFill]: '62130',
  [PrizmIconType.NotificationsAlertsCircleQuestionEmpty]: '62131',
  [PrizmIconType.NotificationsAlertsCircleQuestionFill]: '62132',
  [PrizmIconType.NotificationsAlertsDecagramChekEmpty]: '62133',
  [PrizmIconType.NotificationsAlertsDecagramChekFill]: '62134',
  [PrizmIconType.NotificationsAlertsDecagramExclamationEmpty]: '62135',
  [PrizmIconType.NotificationsAlertsDecagramExclamationFill]: '62136',
  [PrizmIconType.NotificationsAlertsExclamation]: '62137',
  [PrizmIconType.NotificationsAlertsFlagFillRed]: '62138',
  [PrizmIconType.NotificationsAlertsFlagFill]: '62139',
  [PrizmIconType.NotificationsAlertsFlag]: '62140',
  [PrizmIconType.NotificationsAlertsHexagonExclamationEmpty]: '62141',
  [PrizmIconType.NotificationsAlertsHexagonExclamationFill]: '62142',
  [PrizmIconType.NotificationsAlertsInfo]: '62143',
  [PrizmIconType.NotificationsAlertsQuestion]: '62144',
  [PrizmIconType.NotificationsAlertsSquareExclamationEmpty]: '62145',
  [PrizmIconType.NotificationsAlertsSquareExclamationFill]: '62146',
  [PrizmIconType.NotificationsAlertsSquareInfoEmpty]: '62147',
  [PrizmIconType.NotificationsAlertsSquareInfoFill]: '62148',
  [PrizmIconType.NotificationsAlertsSquareQuestionEmpty]: '62149',
  [PrizmIconType.NotificationsAlertsSquareQuestionFill]: '62150',
  [PrizmIconType.NotificationsAlertsTriangleCrossEmpty]: '62151',
  [PrizmIconType.NotificationsAlertsTriangleExclamationEmpty]: '62152',
  [PrizmIconType.NotificationsAlertsTriangleExclamationFill]: '62153',
  [PrizmIconType.NotificationsAlertsTriangleInfoEmpty]: '62154',
  [PrizmIconType.NotificationsAlertsTriangleInfoFill]: '62155',
  [PrizmIconType.NotificationsAlertsTrianglePlusEmpty]: '62156',
  [PrizmIconType.OtherAward]: '62157',
  [PrizmIconType.OtherDefaultIco]: '62158',
  [PrizmIconType.OtherFaceFrown]: '62159',
  [PrizmIconType.OtherFaceSmile]: '62160',
  [PrizmIconType.OtherGitLab]: '62161',
  [PrizmIconType.OtherInstagram]: '62162',
  [PrizmIconType.OtherLogoGreyZ]: '62163',
  [PrizmIconType.OtherLogoSGrey]: '62164',
  [PrizmIconType.OtherMapMarkerDate_1]: '62165',
  [PrizmIconType.OtherMapMarkerDate_2]: '62166',
  [PrizmIconType.OtherOwl]: '62167',
  [PrizmIconType.OtherPortfel]: '62168',
  [PrizmIconType.OtherTemperatureMinus]: '62169',
  [PrizmIconType.OtherTemperaturePlus]: '62170',
  [PrizmIconType.OtherTemperature]: '62171',
  [PrizmIconType.OtherTemplate]: '62172',
  [PrizmIconType.OtherUmbrella]: '62173',
  [PrizmIconType.PowerEnergyBatteryBolt]: '62174',
  [PrizmIconType.PowerEnergyBatteryEmpty]: '62175',
  [PrizmIconType.PowerEnergyBatteryExclametionMark]: '62176',
  [PrizmIconType.PowerEnergyBatteryFull]: '62177',
  [PrizmIconType.PowerEnergyBatteryHalf]: '62178',
  [PrizmIconType.PowerEnergyBatteryMinus]: '62179',
  [PrizmIconType.PowerEnergyBatteryPlus]: '62180',
  [PrizmIconType.PowerEnergyBatteryQuarter]: '62181',
  [PrizmIconType.PowerEnergyBatteryThreeQuarters]: '62182',
  [PrizmIconType.PowerEnergyEnergyCheck]: '62183',
  [PrizmIconType.PowerEnergyEnergySlash]: '62184',
  [PrizmIconType.PowerEnergyEnergy]: '62185',
  [PrizmIconType.PowerEnergyPulse]: '62186',
  [PrizmIconType.ProductionIndustryBalloon]: '62187',
  [PrizmIconType.ProductionIndustryBoilerHotWaterGasAndOil]: '62188',
  [PrizmIconType.ProductionIndustryBoiler]: '62189',
  [PrizmIconType.ProductionIndustryBurn]: '62190',
  [PrizmIconType.ProductionIndustryCarbon]: '62191',
  [PrizmIconType.ProductionIndustryCartFlatbedContainer]: '62192',
  [PrizmIconType.ProductionIndustryContainer_2]: '62193',
  [PrizmIconType.ProductionIndustryContainer]: '62194',
  [PrizmIconType.ProductionIndustryContainers]: '62195',
  [PrizmIconType.ProductionIndustryCrane]: '62196',
  [PrizmIconType.ProductionIndustryCubeEmpty]: '62197',
  [PrizmIconType.ProductionIndustryCubeFill]: '62198',
  [PrizmIconType.ProductionIndustryCubes]: '62199',
  [PrizmIconType.ProductionIndustryEarlyVersion]: '62200',
  [PrizmIconType.ProductionIndustryElectrics]: '62201',
  [PrizmIconType.ProductionIndustryExchanger]: '62202',
  [PrizmIconType.ProductionIndustryFactoryPipe]: '62203',
  [PrizmIconType.ProductionIndustryFactoryPipes]: '62204',
  [PrizmIconType.ProductionIndustryFactory]: '62205',
  [PrizmIconType.ProductionIndustryFan]: '62206',
  [PrizmIconType.ProductionIndustryFire]: '62207',
  [PrizmIconType.ProductionIndustryFlaskRoundPotion]: '62208',
  [PrizmIconType.ProductionIndustryFlask]: '62209',
  [PrizmIconType.ProductionIndustryFuelOilTank]: '62210',
  [PrizmIconType.ProductionIndustryGasMonitoring]: '62211',
  [PrizmIconType.ProductionIndustryGasPump]: '62212',
  [PrizmIconType.ProductionIndustryGas]: '62213',
  [PrizmIconType.ProductionIndustryGearCooling]: '62214',
  [PrizmIconType.ProductionIndustryGenerator]: '62215',
  [PrizmIconType.ProductionIndustryLngStorage]: '62216',
  [PrizmIconType.ProductionIndustryMedical]: '62217',
  [PrizmIconType.ProductionIndustryNiFiLogo]: '62218',
  [PrizmIconType.ProductionIndustryOilBarrel]: '62219',
  [PrizmIconType.ProductionIndustryOilCanister]: '62220',
  [PrizmIconType.ProductionIndustryOilDropletArrowsAll]: '62221',
  [PrizmIconType.ProductionIndustryOilDropletArrowsRepeatH]: '62222',
  [PrizmIconType.ProductionIndustryOilDropletChek]: '62223',
  [PrizmIconType.ProductionIndustryOilDroplet]: '62224',
  [PrizmIconType.ProductionIndustryOilField]: '62225',
  [PrizmIconType.ProductionIndustryOilTank]: '62226',
  [PrizmIconType.ProductionIndustryPipeSensor]: '62227',
  [PrizmIconType.ProductionIndustryPipeValve]: '62228',
  [PrizmIconType.ProductionIndustryPipeline_2]: '62229',
  [PrizmIconType.ProductionIndustryPipeline]: '62230',
  [PrizmIconType.ProductionIndustryPress]: '62231',
  [PrizmIconType.ProductionIndustryPumpTriangleDown]: '62232',
  [PrizmIconType.ProductionIndustryPump]: '62233',
  [PrizmIconType.ProductionIndustryRadiation]: '62234',
  [PrizmIconType.ProductionIndustryRespirator_1]: '62235',
  [PrizmIconType.ProductionIndustryRespirator_2]: '62236',
  [PrizmIconType.ProductionIndustryRespirator_3]: '62237',
  [PrizmIconType.ProductionIndustryRespirator_4]: '62238',
  [PrizmIconType.ProductionIndustryRespirator_5]: '62239',
  [PrizmIconType.ProductionIndustryRespirator_6]: '62240',
  [PrizmIconType.ProductionIndustrySeedlingCircle]: '62241',
  [PrizmIconType.ProductionIndustrySeedlingRectangle]: '62242',
  [PrizmIconType.ProductionIndustrySeedling]: '62243',
  [PrizmIconType.ProductionIndustrySeparator]: '62244',
  [PrizmIconType.ProductionIndustrySnakeCup]: '62245',
  [PrizmIconType.ProductionIndustrySnowflakeUpToBracket]: '62246',
  [PrizmIconType.ProductionIndustrySnowflake]: '62247',
  [PrizmIconType.ProductionIndustrySpeedReductionCooling]: '62248',
  [PrizmIconType.ProductionIndustrySteamBoiler]: '62249',
  [PrizmIconType.ProductionIndustrySteamTurbine]: '62250',
  [PrizmIconType.ProductionIndustrySteam]: '62251',
  [PrizmIconType.ProductionIndustryTank_1]: '62252',
  [PrizmIconType.ProductionIndustryTank]: '62253',
  [PrizmIconType.ProductionIndustryVialArrowRotateLeft]: '62254',
  [PrizmIconType.ProductionIndustryVialFlask]: '62255',
  [PrizmIconType.ProductionIndustryVialXmark]: '62256',
  [PrizmIconType.ProductionIndustryVial]: '62257',
  [PrizmIconType.ProductionIndustryWaterHeater]: '62258',
  [PrizmIconType.ProductionIndustryWaterPump]: '62259',
  [PrizmIconType.SettingsToolsBan]: '62260',
  [PrizmIconType.SettingsToolsBars]: '62261',
  [PrizmIconType.SettingsToolsCirclePlusFill]: '62262',
  [PrizmIconType.SettingsToolsCirclePlus]: '62263',
  [PrizmIconType.SettingsToolsCircleXmarkFill]: '62264',
  [PrizmIconType.SettingsToolsCircleXmark]: '62265',
  [PrizmIconType.SettingsToolsCopy]: '62266',
  [PrizmIconType.SettingsToolsDeleteContent]: '62267',
  [PrizmIconType.SettingsToolsDropletSlash]: '62268',
  [PrizmIconType.SettingsToolsDroplet]: '62269',
  [PrizmIconType.SettingsToolsEllipsisGrid]: '62270',
  [PrizmIconType.SettingsToolsEllipsisH]: '62271',
  [PrizmIconType.SettingsToolsEllipsisV]: '62272',
  [PrizmIconType.SettingsToolsEyeClosed]: '62273',
  [PrizmIconType.SettingsToolsEyeSlash]: '62274',
  [PrizmIconType.SettingsToolsEye]: '62275',
  [PrizmIconType.SettingsToolsFilter]: '62276',
  [PrizmIconType.SettingsToolsGear_5]: '62277',
  [PrizmIconType.SettingsToolsGear_8]: '62278',
  [PrizmIconType.SettingsToolsGripDotsVertical]: '62279',
  [PrizmIconType.SettingsToolsHouseMini]: '62280',
  [PrizmIconType.SettingsToolsHouse]: '62281',
  [PrizmIconType.SettingsToolsKey]: '62282',
  [PrizmIconType.SettingsToolsLibraryPlus]: '62283',
  [PrizmIconType.SettingsToolsLightbulb]: '62284',
  [PrizmIconType.SettingsToolsLinkBreak]: '62285',
  [PrizmIconType.SettingsToolsLinkMinus]: '62286',
  [PrizmIconType.SettingsToolsLinkPlus]: '62287',
  [PrizmIconType.SettingsToolsLinkSimpleH]: '62288',
  [PrizmIconType.SettingsToolsLinkSimple]: '62289',
  [PrizmIconType.SettingsToolsLoader]: '62290',
  [PrizmIconType.SettingsToolsLock]: '62291',
  [PrizmIconType.SettingsToolsMagnifyingGlassExclamation]: '62292',
  [PrizmIconType.SettingsToolsMagnifyingGlassMinus]: '62293',
  [PrizmIconType.SettingsToolsMagnifyingGlassPlus]: '62294',
  [PrizmIconType.SettingsToolsMagnifyingGlassTopFromBracket]: '62295',
  [PrizmIconType.SettingsToolsMagnifyingGlassTriangleDown]: '62296',
  [PrizmIconType.SettingsToolsMagnifyingGlassXmark]: '62297',
  [PrizmIconType.SettingsToolsMagnifyingGlass]: '62298',
  [PrizmIconType.SettingsToolsMinusCircleFill]: '62299',
  [PrizmIconType.SettingsToolsMinusCircle]: '62300',
  [PrizmIconType.SettingsToolsMinus]: '62301',
  [PrizmIconType.SettingsToolsMoon]: '62302',
  [PrizmIconType.SettingsToolsPaperclipVertical]: '62303',
  [PrizmIconType.SettingsToolsPaperclip]: '62304',
  [PrizmIconType.SettingsToolsPenHammer]: '62305',
  [PrizmIconType.SettingsToolsPencilArrowRight]: '62306',
  [PrizmIconType.SettingsToolsPencilTriangleDown]: '62307',
  [PrizmIconType.SettingsToolsPencilTriangleLeft]: '62308',
  [PrizmIconType.SettingsToolsPencilLineBottom]: '62309',
  [PrizmIconType.SettingsToolsPencil]: '62310',
  [PrizmIconType.SettingsToolsPipette]: '62311',
  [PrizmIconType.SettingsToolsPlus]: '62312',
  [PrizmIconType.SettingsToolsPower]: '62313',
  [PrizmIconType.SettingsToolsShieldExclamation]: '62314',
  [PrizmIconType.SettingsToolsShieldSlash]: '62315',
  [PrizmIconType.SettingsToolsShield]: '62316',
  [PrizmIconType.SettingsToolsSlidersH]: '62317',
  [PrizmIconType.SettingsToolsSlidersV]: '62318',
  [PrizmIconType.SettingsToolsSun]: '62319',
  [PrizmIconType.SettingsToolsTrashEmpty]: '62320',
  [PrizmIconType.SettingsToolsTrash]: '62321',
  [PrizmIconType.SettingsToolsUnlock]: '62322',
  [PrizmIconType.SettingsToolsWrench]: '62323',
  [PrizmIconType.SettingsToolsXmarkMini]: '62324',
  [PrizmIconType.SettingsToolsXmark]: '62325',
  [PrizmIconType.ShapeGeometryArrangeSendToBack]: '62326',
  [PrizmIconType.ShapeGeometryCheckerboard]: '62327',
  [PrizmIconType.ShapeGeometryCircleSquareInSquare]: '62328',
  [PrizmIconType.ShapeGeometryCircleSquareFill_1]: '62329',
  [PrizmIconType.ShapeGeometryCircleSquareFill]: '62330',
  [PrizmIconType.ShapeGeometryCircleInHexagon]: '62331',
  [PrizmIconType.ShapeGeometryCirclesLineLeftUpCircleRightDownFill]: '62332',
  [PrizmIconType.ShapeGeometryCirclesLineLeftUpCircleRightDown]: '62333',
  [PrizmIconType.ShapeGeometryCollector]: '62334',
  [PrizmIconType.ShapeGeometryDiscreteSet]: '62335',
  [PrizmIconType.ShapeGeometryHexagonFill]: '62336',
  [PrizmIconType.ShapeGeometryHexagon]: '62337',
  [PrizmIconType.ShapeGeometryPentagonFill]: '62338',
  [PrizmIconType.ShapeGeometryPentagon]: '62339',
  [PrizmIconType.ShapeGeometryRhombusFill]: '62340',
  [PrizmIconType.ShapeGeometryRhombus]: '62341',
  [PrizmIconType.ShapeGeometryRingInSquare]: '62342',
  [PrizmIconType.ShapeGeometryShape_4F]: '62343',
  [PrizmIconType.ShapeGeometryShape_4]: '62344',
  [PrizmIconType.ShapeGeometryShape_6]: '62345',
  [PrizmIconType.ShapeGeometryShape_7]: '62346',
  [PrizmIconType.ShapeGeometryShapePlus]: '62347',
  [PrizmIconType.ShapeGeometrySquareCirclePlusTriangleFill]: '62348',
  [PrizmIconType.ShapeGeometrySquareCircleTriangleCrossFill]: '62349',
  [PrizmIconType.ShapeGeometrySquareCircleTriangleCross]: '62350',
  [PrizmIconType.ShapeGeometrySquareHexagonCircleFill]: '62351',
  [PrizmIconType.ShapeGeometrySquareHexagonCircle]: '62352',
  [PrizmIconType.ShapeGeometrySquareTriangleCircleTriangleFill_1]: '62353',
  [PrizmIconType.ShapeGeometrySquareTriangleCircleTriangleFill]: '62354',
  [PrizmIconType.ShapeGeometrySquareInSquare]: '62355',
  [PrizmIconType.ShapeGeometryTriangleCircleSquareFill_1]: '62356',
  [PrizmIconType.ShapeGeometryTriangleCircleSquareFill]: '62357',
  [PrizmIconType.ShapeGeometryTriangleFill]: '62358',
  [PrizmIconType.ShapeGeometryTriangle]: '62359',
  [PrizmIconType.UserAccountUserArrowsSwap]: '62360',
  [PrizmIconType.UserAccountUserCard]: '62361',
  [PrizmIconType.UserAccountUserCheck]: '62362',
  [PrizmIconType.UserAccountUserCircle]: '62363',
  [PrizmIconType.UserAccountUserCross]: '62364',
  [PrizmIconType.UserAccountUserGear]: '62365',
  [PrizmIconType.UserAccountUserLocation]: '62366',
  [PrizmIconType.UserAccountUserMinus]: '62367',
  [PrizmIconType.UserAccountUserPen]: '62368',
  [PrizmIconType.UserAccountUserPlus]: '62369',
  [PrizmIconType.UserAccountUserShield]: '62370',
  [PrizmIconType.UserAccountUserWorker]: '62371',
  [PrizmIconType.UserAccountUser]: '62372',
  [PrizmIconType.UserAccountUsersArrowRight]: '62373',
  [PrizmIconType.UserAccountUsersGear]: '62374',
  [PrizmIconType.UserAccountUsersKey]: '62375',
  [PrizmIconType.UserAccountUsersLocation]: '62376',
  [PrizmIconType.UserAccountUsersMinus]: '62377',
  [PrizmIconType.UserAccountUsersPlus]: '62378',
  [PrizmIconType.UserAccountUsers]: '62379',
};
